// src/screens/recruit/RecruitDetailScreen.js
// 20차: 참가 승인 시스템 (신청→수락/거절), 참가자 프로필 카드
// 21차: 테마 이미지, 참가자 프로필 사진, 신고, 재모집
// 22차: 댓글 시간 위치 개선, 신고 addDoc 수정, 모집완료 프로세스,
//       작성자 프로필 미리보기 모달, D-Day 뱃지
// 23차: 자물쇠 아이콘 제거, 매장정보 productId 실시간 조회 보완,
//       모집 완료 후 일괄 예약 기능 추가
// 51차: 색 theme.js 단일화 — 자체 색 정의 제거, COLORS 참조 / 초록·빨강·주황·보라 통일
// 74차: 작성자명 옆 [크루명] 태그 표시 (recruit.authorCrewName 스냅샷)
// 75차: 자체 커스텀 헤더 → 공통 AppHeader로 교체(신고/수정/삭제는 rightElement로).
// 상단노출(⭐부스트) 포인트 차감이 클라이언트에서 users.points를 직접 updateDoc해서
// firestore.rules(53차, points 필드 클라 직접 수정 차단)에 막혀 항상 permission-denied
// 였던 버그 수정 — 크루 생성과 동일한 usePointsFIFO(CF 래퍼)로 교체.
// 77차: design 폴더(design_handoff_unlock) 버튼 시스템 반영 — 헤더 수정/삭제, 하단
// 참가신청/참가취소 버튼을 공용 SecondaryButton/DangerButton/GradientButton으로 교체.
// D-Day 뱃지는 셸(pill 모양)만 스펙 정합, 기존 3단계(오늘/3일이내/그 외) 색 로직은
// 정보량이 더 많아 그대로 유지(공용 DDayBadge는 2단계라 강등시키지 않음).
// 78차: 77차에서 빠졌던 나머지 버튼(작성자 모달 닫기/로그인 유도/거절 후 다른 글 보기/
// 댓글·대댓글 전송)도 공용 Secondary/TextButton/GradientButton으로 교체.
// 78차: "상단노출" 버튼이 본문 중간에 큰 골드 배너로 있어 "너무 크고 한가운데"
// 신고됨 — 헤더의 수정/삭제와 같은 소형 버튼 톤으로 옮기고 축소, 본문 배너 삭제.
// 80차 후속: [버그 수정, 실기기 신고] 하단 고정 액션 버튼(footer)의 paddingBottom이
// 32 하드코딩이라 안드로이드 3버튼 내비게이션(실측 ~48px)에 버튼이 가려 보였음 —
// 이 화면은 탭 네비게이터가 아닌 Stack 전용 화면(navigation/index.js)이라 앱 자체
// 탭바가 없어, 시스템 내비게이션 바 여백을 직접 안 챙기면 그대로 노출됨.
// EventsScreen.js에서 같은 유형의 버그가 하나 더 나와서 useBottomSafePadding
// (src/hooks/useBottomSafePadding.js)으로 공용화 — 새로 만드는 하단 고정 버튼은
// 이 훅을 쓸 것(탭 네비게이터 안/밖 여부를 직접 판별해 이중으로 여백을 더하지 않음).

import React, { useState, useEffect, useRef } from 'react';
import { showAlert } from '../../components/common/AppAlert';
import {
  View, Text, ScrollView, TouchableOpacity, StyleSheet,
  ActivityIndicator, Linking, TextInput,
  KeyboardAvoidingView, Platform, Modal, findNodeHandle, Share,
} from 'react-native';
// 78차 37차: 썸네일/아바타 캐싱 없이 매번 재다운로드되던 것 — expo-image로 교체(디스크 캐시 자동)
import { Image } from 'expo-image';
import { Ionicons } from '@expo/vector-icons';
import {
  collection, doc, addDoc, getDocs, query,
  orderBy, serverTimestamp, deleteDoc, updateDoc,
  arrayUnion, arrayRemove,
} from 'firebase/firestore';
import { useBottomSafePadding } from '../../hooks/useBottomSafePadding';
import { db } from '../../services/firebase';
import AppHeader from '../../components/common/AppHeader';
import {
  getRecruitById,
  leaveRecruit,
  deleteRecruit,
  getParticipantProfiles,
  requestJoinRecruit,
  cancelJoinRequest,
  approveParticipant,
  rejectParticipant,
  requestSeatTransfer,
  cancelSeatTransfer,
  approveSeatTransfer,
  submitPeerRating,
  getMyPeerRatings,
  getMannerCount,
  getPendingProfiles,
  submitReportSafe,
  bulkReserveForRecruit,
  bulkReserveShowForRecruit,
  cancelBulkRoomReservation,
  cancelBulkShowReservation,
  checkAlreadyReported,
  addReportedRecruit,
  usePointsFIFO,
  addRecruitChatMessage,
  listenRecruitChatMessages,
} from '../../services/recruitService';
import { getProductById } from '../../services/productService';
// reservationService: 일괄예약은 recruitService.bulkReserveForRecruit 사용
import { useAuth } from '../../contexts/AuthContext';
import LoadingOverlay from '../../components/common/LoadingOverlay';
import { SecondaryButton, DangerButton, TextButton } from '../../components/common/Buttons';
import GradientButton from '../../components/common/GradientButton';
import {
  GenreIcon, MenuStoreIcon, MenuReservationIcon, MenuPointsIcon, PeopleIcon,
  LocationIcon, RefreshIcon, IconLabel,
  CheckmarkIcon, CancelIcon, ViewsIcon, ClockIcon, ParticipantAcceptIcon,
  RecruitRejectedIcon, RecruitAppliedIcon, CrewMessageIcon, MenuInquiryIcon,
  WarningIcon, CrownIcon, ReportFlagIcon, PrivacyLockIcon, PersonIcon, HourglassIcon,
  EditIcon, ShareIcon, MannerLikeIcon, MatchCompleteIcon,
} from '../../components/common/Icons';
import { COLORS } from '../../constants/theme';
import { isConfirmedMinorBirth } from '../../utils/dateUtils';

const GOLD     = COLORS.gold;
const BG       = COLORS.bg;
const SURFACE  = COLORS.surface;
const SURFACE2 = COLORS.surface2;
const BORDER   = COLORS.border;
const TEXT     = COLORS.text;
const TEXT_SEC = COLORS.textSec;
const TEXT_MUTED = COLORS.textMuted;
const RED      = COLORS.red;
const GREEN    = COLORS.green;
const ORANGE   = COLORS.orange;
const PURPLE   = COLORS.purple;

// ── 작성자 프로필 모달 (독립 컴포넌트 — 부모 리렌더로 언마운트되지 않도록 분리)
function AuthorProfileModal({ visible, profile: authorProfile, onClose, getLevel }) {
  if (!authorProfile) return null;
  const level = getLevel(authorProfile.escapeStats?.total);
  const isPrivate = authorProfile.statsPrivate === true;
  const avatarLetter = (authorProfile.nickname || authorProfile.displayName || '?')[0].toUpperCase();
  return (
    <Modal
      visible={visible}
      transparent
      animationType="fade"
      onRequestClose={onClose}>
      <TouchableOpacity style={s.modalOverlay} activeOpacity={1} onPress={onClose}>
        <View style={s.authorModal}>
          <View style={s.authorModalTop}>
            {authorProfile.photoURL ? (
              <Image source={{ uri: authorProfile.photoURL }} style={s.authorModalAvatar} />
            ) : (
              <View style={s.authorModalAvatarFallback}>
                <Text style={{ fontSize: 22, color: GOLD }}>{avatarLetter}</Text>
              </View>
            )}
            <View style={{ flex: 1 }}>
              <Text style={s.authorModalName}>
                {authorProfile.nickname || authorProfile.displayName || '익명'}
              </Text>
              <View style={[s.levelBadge, { borderColor: level.color+'60', backgroundColor: level.color+'15', alignSelf:'flex-start' }]}>
                <Text style={[s.levelTxt, { color: level.color }]}>{level.label}</Text>
              </View>
            </View>
          </View>
          {authorProfile.bio ? (
            <Text style={s.authorModalBio}>"{authorProfile.bio}"</Text>
          ) : null}
          {/* 80차 계속: 낯선 사람끼리 신청/수락을 판단할 신뢰 신호 — 노쇼 이력은
              항상 노출(계정 전체에 적용되는 제재 사유라 비공개 대상 아님), 선호 장르는
              statsPrivate(탈출기록 비공개) 토글을 그대로 존중. 성공률(escapeStats 기반,
              애초에 아무도 안 써주는 죽은 필드라 항상 "-"만 뜨던 것)은 낮으면 노출이
              꺼려질 수 있다는 판단으로 제거. */}
          <View style={s.statsRow}>
            <View style={s.statItem}>
              <Text style={[s.statVal, { color: (authorProfile.recentNoShowCount || 0) > 0 ? ORANGE : GREEN }]}>
                {(authorProfile.recentNoShowCount || 0) > 0 ? `${authorProfile.recentNoShowCount}회` : '없음'}
              </Text>
              {/* 80차 계속: 생애 누적 대신 최근 180일 기준 — 한 번의 실수가 영구 낙인이 되지 않도록 */}
              <Text style={s.statLbl}>최근 노쇼</Text>
            </View>
            <View style={s.statItem}>
              <Text style={[s.statVal, { color: GOLD }]} numberOfLines={1}>
                {isPrivate ? '비공개' : (authorProfile.favoriteGenre || '-')}
              </Text>
              <Text style={s.statLbl}>선호 장르</Text>
            </View>
          </View>
          )}
          <TextButton label="닫기" onPress={onClose} style={s.authorModalClose} textStyle={{ color: TEXT_MUTED, fontSize: 13 }} />
        </View>
      </TouchableOpacity>
    </Modal>
  );
}

// ── 일괄 예약 모달 (독립 컴포넌트 — state 변경 시 리마운트 방지)
function BulkReserveModal({
  visible, onClose,
  recruit, participantProfiles, displayThemeName, displayStoreName,
  reserveLoading, reserveResults,
  onExecute,
}) {
  const allDone = reserveResults.length > 0;
  const successCount = reserveResults.filter(r => r.status === 'success').length;
  const hasSlotError = reserveResults.some(r => r.status === 'slot_taken');

  return (
    <Modal
      visible={visible}
      transparent
      animationType="slide"
      onRequestClose={() => !reserveLoading && onClose()}>
      <View style={s.modalOverlay}>
        <View style={[s.authorModal, { maxHeight: '80%' }]}>
          {/* 헤더 */}
          <View style={{ flexDirection:'row', alignItems:'center', justifyContent:'space-between', marginBottom:16 }}>
            <IconLabel Icon={MenuReservationIcon} size={16} color={TEXT} textStyle={{ color:TEXT, fontSize:16, fontWeight:'900' }}>일괄 예약</IconLabel>
            {!reserveLoading && (
              <TouchableOpacity onPress={onClose}>
                <Text style={{ color:TEXT_MUTED, fontSize:13 }}>닫기</Text>
              </TouchableOpacity>
            )}
          </View>

          {/* 예약 정보 요약 */}
          <View style={s.bulkInfoBox}>
            <IconLabel Icon={GenreIcon} size={12} color={TEXT_SEC} textStyle={s.bulkInfoRow}>{displayThemeName || '테마 미정'}</IconLabel>
            <IconLabel Icon={MenuStoreIcon} size={12} color={TEXT_SEC} textStyle={s.bulkInfoRow}>{displayStoreName || '매장 정보 없음'}</IconLabel>
            <View style={{ flexDirection:'row', alignItems:'center', gap:10 }}>
              <IconLabel Icon={MenuReservationIcon} size={12} color={TEXT_SEC} textStyle={s.bulkInfoRow}>{recruit?.scheduledDate}</IconLabel>
              <IconLabel Icon={MenuPointsIcon} size={12} color={TEXT_SEC} textStyle={s.bulkInfoRow}>{recruit?.scheduledTime}</IconLabel>
            </View>
            <IconLabel Icon={PeopleIcon} size={12} color={TEXT_SEC} textStyle={s.bulkInfoRow}>{recruit?.participants?.length || 1}명 일괄 예약</IconLabel>
          </View>

          {!allDone ? (
            <>
              <ScrollView style={{ maxHeight: 200 }} showsVerticalScrollIndicator={false}>
                {participantProfiles.map(p => (
                  <View key={p.uid} style={s.bulkParticipantRow}>
                    {p.photoURL ? (
                      <Image source={{ uri: p.photoURL }} style={s.bulkAvatar} />
                    ) : (
                      <View style={[s.bulkAvatar, { backgroundColor: GOLD+'20', alignItems:'center', justifyContent:'center' }]}>
                        <Text style={{ color:GOLD, fontSize:12, fontWeight:'800' }}>
                          {(p.nickname||'?')[0].toUpperCase()}
                        </Text>
                      </View>
                    )}
                    <View style={{ flexDirection:'row', alignItems:'center', gap:4 }}>
                      <Text style={{ color:TEXT, fontSize:13, fontWeight:'600' }}>
                        {p.nickname || p.displayName || '익명'}
                      </Text>
                      {p.uid === recruit?.uid && <CrownIcon size={12} color={GOLD} />}
                    </View>
                  </View>
                ))}
              </ScrollView>

              <Text style={{ color:TEXT_MUTED, fontSize:11, marginTop:10, marginBottom:14, lineHeight:16 }}>
                위 참가자 전원의 예약이 자동으로 등록됩니다.{'\n'}
                이미 해당 슬롯에 예약이 있는 경우 실패할 수 있습니다.
              </Text>

              <TouchableOpacity
                style={[s.bulkReserveExecuteBtn, reserveLoading && { opacity:0.6 }]}
                onPress={onExecute}
                disabled={reserveLoading}>
                {reserveLoading ? (
                  <View style={{ flexDirection:'row', gap:10, alignItems:'center' }}>
                    <ActivityIndicator color={BG} size="small" />
                    <Text style={s.bulkReserveExecuteTxt}>예약 진행 중...</Text>
                  </View>
                ) : (
                  <Text style={s.bulkReserveExecuteTxt}>🚀 예약 시작</Text>
                )}
              </TouchableOpacity>
            </>
          ) : (
            <>
              {hasSlotError ? (
                <View style={s.bulkResultError}>
                  <IconLabel Icon={WarningIcon} size={14} color={RED} textStyle={{ color:RED, fontSize:14, fontWeight:'800' }} style={{ marginBottom:4 }}>슬롯 중복</IconLabel>
                  <Text style={{ color:TEXT_SEC, fontSize:12, lineHeight:18 }}>
                    해당 날짜·시간에 이미 다른 예약이 존재합니다.{'\n'}
                    관리자에게 문의하거나 다른 시간을 선택해주세요.
                  </Text>
                </View>
              ) : (
                <>
                  <View style={[s.bulkResultSummary, { flexDirection:'row', alignItems:'center', gap:10 }]}>
                    <IconLabel Icon={CheckmarkIcon} size={13} color={COLORS.success} gap={4} textStyle={s.bulkResultSummaryTxt}>
                      {`${successCount}명 예약 완료`}
                    </IconLabel>
                    {successCount < reserveResults.length && (
                      <IconLabel Icon={WarningIcon} size={13} color={COLORS.danger} gap={4} textStyle={s.bulkResultSummaryTxt}>
                        {`${reserveResults.length - successCount}명 실패`}
                      </IconLabel>
                    )}
                  </View>
                  <ScrollView style={{ maxHeight: 180 }} showsVerticalScrollIndicator={false}>
                    {reserveResults.map(r => (
                      <View key={r.uid} style={s.bulkResultRow}>
                        <View style={{ width:20 }}>
                          {r.status === 'success'
                            ? <CheckmarkIcon size={14} color={GREEN} />
                            : <CancelIcon size={14} color={RED} />}
                        </View>
                        <View style={{ flex:1 }}>
                          <Text style={{ color:TEXT, fontSize:13 }}>{r.name}</Text>
                          {r.status === 'error' && r.message ? (
                            <Text style={{ color:RED, fontSize:10, marginTop:2 }}>{r.message}</Text>
                          ) : null}
                        </View>
                        <Text style={{ color:r.status === 'success' ? GREEN : RED, fontSize:11 }}>
                          {r.status === 'success' ? '완료' : '실패'}
                        </Text>
                      </View>
                    ))}
                  </ScrollView>
                </>
              )}
              <TouchableOpacity
                style={[s.bulkReserveExecuteBtn, { backgroundColor:SURFACE2, borderWidth:1, borderColor:BORDER, marginTop:14 }]}
                onPress={onClose}>
                <Text style={{ color:TEXT_SEC, fontSize:14, fontWeight:'700' }}>닫기</Text>
              </TouchableOpacity>
            </>
          )}
        </View>
      </View>
    </Modal>
  );
}

// 80차 계속: 댓글/대댓글 좋아요 버튼 — likedBy(uid 배열)를 arrayUnion/arrayRemove로
// 토글(firestore.rules가 본인 uid 자기토글만 허용). 낙관적 로컬 갱신 후 실패 시 되돌림.
function LikeButton({ liked, count, onToggle, disabled }) {
  return (
    <TouchableOpacity onPress={onToggle} disabled={disabled}
      style={{ flexDirection: 'row', alignItems: 'center', gap: 3 }}
      hitSlop={{ top: 8, bottom: 8, left: 8, right: 8 }}>
      <Ionicons name={liked ? 'heart' : 'heart-outline'} size={13} color={liked ? '#ff5f8f' : TEXT_MUTED} />
      {count > 0 && <Text style={{ fontSize: 10, color: liked ? '#ff5f8f' : TEXT_MUTED, fontWeight: '700' }}>{count}</Text>}
    </TouchableOpacity>
  );
}

// ── 대댓글 목록 컴포넌트 ─────────────────────────────────────────────────────
// 78차 66차: count(버튼에 보이는 답글 수)를 마운트 시 한 번만 조회하고 이후 절대
// 갱신하지 않던 버그 — 댓글에 새 답글이 처음 달려도 이 count는 계속 0으로 고정된 채라,
// (펼침 후) 다시 접으면 `count===0 && !expanded`가 참이 되어 토글 버튼 자체가 사라지고
// 다시는 펼칠 방법이 없어짐. count를 매번 실제 답글 목록(replies.length)에서 갱신하도록
// 통합(마운트 시 + 펼칠 때마다 재조회).
function ReplyList({ recruitId, commentId, myUid, expanded, onToggle, formatTime, blockedUsers = [] }) {
  const [replies,  setReplies]  = React.useState([]);
  const [loaded,   setLoaded]   = React.useState(false);
  const [count,    setCount]    = React.useState(0);

  // 79차: 댓글과 동일하게 차단된 유저의 대댓글도 숨김(count/목록 둘 다 필터링된 값 기준)
  const fetchReplies = React.useCallback(() => (
    getDocs(query(
      collection(db, 'recruits', recruitId, 'comments', commentId, 'replies'),
      orderBy('createdAt', 'asc'),
    )).then(snap => {
      const all = snap.docs.map(d => ({ id: d.id, ...d.data() }));
      const list = blockedUsers.length ? all.filter(r => !blockedUsers.includes(r.uid)) : all;
      setReplies(list);
      setCount(list.length);
      return list;
    })
  ), [recruitId, commentId, blockedUsers]);

  React.useEffect(() => { fetchReplies().catch(() => {}); }, [fetchReplies]);

  React.useEffect(() => {
    // 숨기기(collapsed) 시 loaded 리셋 — 다음 펼치기 때 최신 데이터 재로드
    if (!expanded) { setLoaded(false); return; }
    fetchReplies().then(() => setLoaded(true)).catch(() => setLoaded(true));
  }, [expanded, fetchReplies]);

  const handleToggleReplyLike = async (r) => {
    if (!myUid) return;
    const liked = r.likedBy?.includes(myUid);
    setReplies(prev => prev.map(x => x.id === r.id
      ? { ...x, likedBy: liked ? x.likedBy.filter(u => u !== myUid) : [...(x.likedBy||[]), myUid] }
      : x));
    try {
      await updateDoc(doc(db, 'recruits', recruitId, 'comments', commentId, 'replies', r.id), {
        likedBy: liked ? arrayRemove(myUid) : arrayUnion(myUid),
      });
    } catch {
      setReplies(prev => prev.map(x => x.id === r.id ? r : x)); // 실패 시 되돌림
    }
  };

  // 79차: [버그 수정] 댓글은 본인 삭제가 되는데 형제 기능인 대댓글만 삭제 버튼 자체가
  // 없었음(모집글 화면 재정독 fork로 발견) — firestore.rules의 replies 서브컬렉션
  // delete 규칙은 comments와 동일하게 이미 본인 삭제를 허용해두고 있어 백엔드는
  // 준비돼 있었는데 UI만 안 붙어 있던 상태(오타/실언을 되돌릴 방법이 전혀 없었음).
  const handleDeleteReply = (replyId) => {
    showAlert('답글 삭제', '답글을 삭제하시겠습니까?', [
      { text: '취소', style: 'cancel' },
      { text: '삭제', style: 'destructive', onPress: async () => {
        try {
          await deleteDoc(doc(db, 'recruits', recruitId, 'comments', commentId, 'replies', replyId));
          setReplies(prev => {
            const next = prev.filter(r => r.id !== replyId);
            setCount(next.length);
            return next;
          });
        } catch { showAlert('오류', '삭제에 실패했습니다.'); }
      }},
    ]);
  };

  if (count === 0 && !expanded) return null;

  return (
    <View style={{ marginTop: 6 }}>
      <TouchableOpacity onPress={onToggle} style={{ alignSelf: 'flex-start' }}>
        <Text style={{ color: TEXT_MUTED, fontSize: 11, fontWeight: '700' }}>
          {expanded ? '▲ 답글 숨기기' : `▼ 답글 ${count}개 보기`}
        </Text>
      </TouchableOpacity>
      {expanded && (
        <View style={{ marginTop: 6, gap: 6, paddingLeft: 12,
          borderLeftWidth: 2, borderLeftColor: 'rgba(212,168,67,0.2)', marginLeft: 4 }}>
          {!loaded ? (
            <ActivityIndicator size="small" color={GOLD} />
          ) : replies.length === 0 ? (
            <Text style={{ color: TEXT_MUTED, fontSize: 11 }}>답글이 없습니다</Text>
          ) : (
            replies.map(r => {
              const isMine = r.uid === myUid;
              const letter = (r.authorName || '?')[0].toUpperCase();
              return (
                <View key={r.id} style={[
                  { backgroundColor: '#0f0f1a', borderRadius: 6, padding: 8,
                    borderWidth: 1, borderColor: 'rgba(255,255,255,0.05)' },
                  isMine && { borderColor: GOLD + '25', backgroundColor: GOLD + '06' },
                ]}>
                  <View style={{ flexDirection: 'row', alignItems: 'center', gap: 5, marginBottom: 3 }}>
                    <View style={{ width: 18, height: 18, borderRadius: 9,
                      backgroundColor: isMine ? GOLD + '20' : 'rgba(255,255,255,0.08)',
                      alignItems: 'center', justifyContent: 'center' }}>
                      <Text style={{ fontSize: 9, fontWeight: '800',
                        color: isMine ? GOLD : 'rgba(255,255,255,0.5)' }}>{letter}</Text>
                    </View>
                    <Text style={{ color: isMine ? GOLD : TEXT_SEC, fontSize: 11, fontWeight: '700' }}>
                      {isMine ? '나' : r.authorName || '익명'}
                    </Text>
                    <View style={{ flex: 1 }} />
                    {r.createdAt && (
                      <Text style={{ color: TEXT_MUTED, fontSize: 10, marginRight: isMine ? 6 : 0 }}>
                        {formatTime(r.createdAt)}
                      </Text>
                    )}
                    {isMine && (
                      <TouchableOpacity onPress={() => handleDeleteReply(r.id)}
                        hitSlop={{ top:8, bottom:8, left:8, right:8 }}>
                        <Text style={{ color: RED, fontSize: 10 }}>삭제</Text>
                      </TouchableOpacity>
                    )}
                  </View>
                  <Text style={{ color: TEXT_SEC, fontSize: 12, lineHeight: 16 }}>{r.text}</Text>
                  <View style={{ marginTop: 4, alignItems: 'flex-end' }}>
                    <LikeButton liked={!!myUid && r.likedBy?.includes(myUid)} count={r.likedBy?.length || 0}
                      onToggle={() => handleToggleReplyLike(r)} disabled={!myUid} />
                  </View>
                </View>
              );
            })
          )}
        </View>
      )}
    </View>
  );
}

export default function RecruitDetailScreen({ route, navigation }) {
  const { recruitId } = route.params;
  const { user, profile, isLoggedIn, refreshProfile } = useAuth();
  const footerPadBottom = useBottomSafePadding(16);

  const [recruit,        setRecruit]        = useState(null);
  const [loading,        setLoading]        = useState(true);
  const [actionLoading,  setActionLoading]  = useState(false);

  const [participantProfiles, setParticipantProfiles] = useState([]);
  const [pendingProfiles,     setPendingProfiles]     = useState([]);

  // 80차 계속: 모임 후 매너 평가 — 내가 이미 평가한 상대(uid 배열), 상대별 누적 집계
  const [myPeerRatings, setMyPeerRatings] = useState([]);
  const [mannerCounts,  setMannerCounts]  = useState({});

  // 상품 정보 (productId로 실시간 조회)
  const [product, setProduct] = useState(null);

  // 79차: [버그 수정] 차단(blockedUsers)이 크루 게시판(CrewScreen.js)/리뷰(ReviewCard.js)
  // 목록엔 이미 적용되고 있는데 이 화면(모집글 댓글·대댓글)엔 전혀 적용이 안 되고 있었음
  // — 전역 설정이라 어디서든 당연히 적용될 거라 기대하는 기능인데, 이 화면만 커버리지가
  // 빠져있었음(전수 정독으로 발견). 참가자 명단(participantProfiles)은 실제 예약 그룹
  // 구성원 명단이라 성격이 달라(차단해도 그 사람은 여전히 같은 그룹으로 예약돼 있음 —
  // 숨기면 오히려 인원 파악에 혼란을 줄 수 있어) 의도적으로 제외, 댓글/대댓글(사회적
  // 피드 성격, 크루 게시판과 동일 범주)만 필터링.
  const blockedUsers = profile?.blockedUsers || [];
  const [comments,       setComments]       = useState([]);
  const [commentText,    setCommentText]    = useState('');
  const [commentLoading, setCommentLoading] = useState(false);
  const [commentsLoaded, setCommentsLoaded] = useState(false);
  // 4번: 대댓글
  const [replyTo,        setReplyTo]        = useState(null);  // { id, authorName }
  const [replyText,      setReplyText]      = useState('');
  const [replyLoading,   setReplyLoading]   = useState(false);
  const [expandedReplies, setExpandedReplies] = useState({});  // { commentId: bool }
  // 80차 계속: 참가자 전용 비공개 채팅 — 댓글과 별개 상태, isParticipant일 때만 구독
  const [chatMessages, setChatMessages] = useState([]);
  const [chatText,     setChatText]     = useState('');
  const [chatSending,  setChatSending]  = useState(false);

  const visibleComments = React.useMemo(
    () => blockedUsers.length ? comments.filter(c => !blockedUsers.includes(c.uid)) : comments,
    [comments, blockedUsers]
  );
  // 80차 계속: 참가자 전용 채팅도 공개 댓글과 동일하게 차단(blockedUsers) 필터링 적용
  // (재검토로 발견 — 새 UGC 렌더마다 이 필터를 빠뜨리는 반복 패턴, 이번에도 빠져있었음).
  const visibleChatMessages = React.useMemo(
    () => blockedUsers.length ? chatMessages.filter(m => !blockedUsers.includes(m.uid)) : chatMessages,
    [chatMessages, blockedUsers]
  );

  // 작성자 프로필 미리보기 모달
  const [authorModalVisible, setAuthorModalVisible] = useState(false);
  const [authorProfile,      setAuthorProfile]      = useState(null);

  // 참가자 명단 접기/펼치기
  const [participantsExpanded, setParticipantsExpanded] = useState(false);

  // 일괄 예약 모달
  const [reserveModalVisible, setReserveModalVisible] = useState(false);
  const [reserveLoading,      setReserveLoading]      = useState(false);
  const [reserveResults,      setReserveResults]      = useState([]); // { uid, name, status }
  // 80차 후속: 방탈출 그룹예약 취소(작성자 전용) 로딩 상태
  const [bulkCancelLoading, setBulkCancelLoading] = useState(false);

  // 신고 상태 (중복 신고 방지용 UI 플래그)
  const [reported, setReported] = useState(false);
  // 상단 노출 부스트 상태
  const [boosting, setBoosting] = useState(false);

  const scrollRef = useRef(null);
  // 80차 계속: [버그 수정] 댓글창 탭 시 키보드에 가려 안 보이던 것 — KeyboardAvoidingView(padding)는
  // 화면 하단 여백만 만들 뿐 포커스된 입력창을 그 안으로 스크롤해주진 않아서, 별도로 위치를
  // 측정해 스크롤해야 함(ScrollView의 자동 스크롤이 안 먹는 케이스).
  const commentInputRef = useRef(null);
  const replyInputRef = useRef(null);
  const chatInputRef = useRef(null);
  const scrollInputIntoView = (ref) => {
    setTimeout(() => {
      ref.current?.measureLayout(
        findNodeHandle(scrollRef.current),
        (x, y) => scrollRef.current?.scrollTo({ y: y - 80, animated: true }),
        () => {}
      );
    }, 150);
  };

  // ── 데이터 로드 ────────────────────────────────────────────
  const loadRecruit = async () => {
    const data = await getRecruitById(recruitId);
    setRecruit(data);

    if (data?.participants?.length) {
      getParticipantProfiles(recruitId).then(setParticipantProfiles).catch(() => {});
    }
    if (data?.pendingParticipants?.length) {
      getPendingProfiles(recruitId).then(setPendingProfiles).catch(() => {});
    } else {
      setPendingProfiles([]);
    }

    // productId가 있으면 실시간으로 상품 정보 조회 (storeName 보완)
    if (data?.productId) {
      getProductById(data.productId).then(setProduct).catch(() => {});
    }

    // 영구 신고 여부 체크 (users/{uid}/reportedRecruits 배열)
    if (user?.uid && data?.id) {
      checkAlreadyReported(user.uid, data.id).then(already => {
        if (already) setReported(true);
      }).catch(() => {});
    }
  };

  useEffect(() => {
    loadRecruit().finally(() => setLoading(false));
  }, [recruitId]);

  // 80차 계속: 모임 후 매너 평가 — 실제 모임이 열렸을(bulkReserved) + 일정이 지났을
  // 때만 의미가 있어 그 전엔 조회 자체를 안 함(불필요한 쿼리 방지).
  useEffect(() => {
    if (!recruit?.bulkReserved || !recruit?.scheduledDate || !user?.uid) return;
    const base = new Date(recruit.scheduledDate);
    if (recruit.scheduledTime) {
      const [h, m] = recruit.scheduledTime.split(':').map(Number);
      base.setHours(h + 2, m, 0, 0);
    } else {
      base.setHours(23, 59, 59, 999);
    }
    if (base >= new Date()) return; // 아직 모임 전
    getMyPeerRatings(recruitId, user.uid).then(setMyPeerRatings).catch(() => {});
    const uids = participantProfiles.map(p => p.uid);
    Promise.all(uids.map(uid => getMannerCount(uid).then(count => [uid, count]).catch(() => [uid, 0])))
      .then(pairs => setMannerCounts(Object.fromEntries(pairs)));
  }, [recruit?.bulkReserved, recruit?.scheduledDate, recruit?.scheduledTime, user?.uid, participantProfiles]);

  useEffect(() => {
    if (!recruitId) return;
    getDocs(query(collection(db, 'recruits', recruitId, 'comments'), orderBy('createdAt', 'asc')))
      .then(snap => setComments(snap.docs.map(d => ({ id: d.id, ...d.data() }))))
      .catch(() => {})
      .finally(() => setCommentsLoaded(true));
  }, [recruitId]);

  // 80차 계속: 참가자 전용 비공개 채팅 구독 — recruit 로딩 전(null)엔 조건이 항상
  // false라 안전하게 스킵, 로딩 완료 후 조건이 맞으면 구독 시작(rules가 실제 접근권한을
  // 다시 강제하므로 여기 조건은 UI 노출용).
  const canSeeChat = !!recruit?.privateChatEnabled && !!recruit?.participants?.includes(user?.uid);
  // 80차 계속(재검토로 발견): 채팅이 댓글과 달리 실시간 구독인데 신규 메시지 도착 시
  // 자동 스크롤이 없었음 — 초기 로딩(0→N)까지 스크롤하면 화면을 열자마자 채팅 섹션으로
  // 강제로 튀는 게 더 어색해서, "이미 보고 있던 중 늘어난" 경우에만 스크롤.
  const chatMsgCountRef = useRef(0);
  useEffect(() => {
    if (!recruitId || !canSeeChat) { setChatMessages([]); chatMsgCountRef.current = 0; return; }
    return listenRecruitChatMessages(recruitId, (msgs) => {
      setChatMessages(msgs);
      if (chatMsgCountRef.current > 0 && msgs.length > chatMsgCountRef.current) {
        setTimeout(() => scrollRef.current?.scrollToEnd({ animated: true }), 100);
      }
      chatMsgCountRef.current = msgs.length;
    });
  }, [recruitId, canSeeChat]);

  const handleSendChat = async () => {
    const text = chatText.trim();
    if (!text) return;
    setChatSending(true);
    try {
      await addRecruitChatMessage({
        recruitId, uid: user.uid,
        nickname: profile?.nickname || profile?.displayName || '익명',
        text,
      });
      setChatText('');
      setTimeout(() => scrollRef.current?.scrollToEnd({ animated: true }), 100);
    } catch { showAlert('오류', '메시지 전송에 실패했어요.'); }
    finally { setChatSending(false); }
  };

  // ── 표시용 매장명 (recruit.storeName 우선, 없으면 product에서 조합) ──
  const displayStoreName = (() => {
    if (recruit?.storeName) return recruit.storeName;
    if (product) {
      const parts = [product.storeName, product.branchName].filter(Boolean);
      return parts.join(' ') || null;
    }
    return null;
  })();

  // ── 표시용 테마명 ──────────────────────────────────────────
  const displayThemeName = recruit?.productName || product?.name || null;

  // ── 댓글 작성 ──────────────────────────────────────────────
  const handleAddComment = async () => {
    if (!isLoggedIn) { showAlert('로그인 필요', '댓글은 로그인 후 작성할 수 있습니다.'); return; }
    const text = commentText.trim();
    if (!text) return;
    setCommentLoading(true);
    try {
      const ref = await addDoc(collection(db, 'recruits', recruitId, 'comments'), {
        uid: user.uid,
        authorName: profile?.nickname || profile?.displayName || '익명',
        photoURL: profile?.photoURL || user?.photoURL || null,
        escapeStats: profile?.escapeStats || null,
        statsPrivate: profile?.statsPrivate || false,
        text,
        createdAt: serverTimestamp(),
      });
      setComments(prev => [...prev, {
        id: ref.id, uid: user.uid,
        authorName: profile?.nickname || '익명',
        photoURL: profile?.photoURL || user?.photoURL || null,
        escapeStats: profile?.escapeStats || null,
        statsPrivate: profile?.statsPrivate || false,
        text, createdAt: null,
      }]);
      setCommentText('');
      setTimeout(() => scrollRef.current?.scrollToEnd({ animated: true }), 100);
    } catch { showAlert('오류', '댓글 작성에 실패했습니다.'); }
    finally { setCommentLoading(false); }
  };

  const handleToggleCommentLike = async (c) => {
    if (!user?.uid) return;
    const liked = c.likedBy?.includes(user.uid);
    setComments(prev => prev.map(x => x.id === c.id
      ? { ...x, likedBy: liked ? x.likedBy.filter(u => u !== user.uid) : [...(x.likedBy||[]), user.uid] }
      : x));
    try {
      await updateDoc(doc(db, 'recruits', recruitId, 'comments', c.id), {
        likedBy: liked ? arrayRemove(user.uid) : arrayUnion(user.uid),
      });
    } catch {
      setComments(prev => prev.map(x => x.id === c.id ? c : x)); // 실패 시 되돌림
    }
  };

  const handleDeleteComment = (commentId) => {
    showAlert('댓글 삭제', '댓글을 삭제하시겠습니까?', [
      { text: '취소', style: 'cancel' },
      { text: '삭제', style: 'destructive', onPress: async () => {
        try {
          await deleteDoc(doc(db, 'recruits', recruitId, 'comments', commentId));
          setComments(prev => prev.filter(c => c.id !== commentId));
        } catch { showAlert('오류', '삭제에 실패했습니다.'); }
      }},
    ]);
  };

  // ── 대댓글 작성 ──────────────────────────────────────────────
  const handleAddReply = async (commentId) => {
    if (!isLoggedIn) { showAlert('로그인 필요', '대댓글은 로그인 후 작성할 수 있습니다.'); return; }
    const text = replyText.trim();
    if (!text) return;
    setReplyLoading(true);
    try {
      await addDoc(collection(db, 'recruits', recruitId, 'comments', commentId, 'replies'), {
        uid:        user.uid,
        authorName: profile?.nickname || profile?.displayName || '익명',
        photoURL:   profile?.photoURL || user?.photoURL || null,
        text,
        createdAt:  serverTimestamp(),
      });
      setReplyText('');
      setReplyTo(null);
      // 대댓글 펼치기 상태 갱신 트리거
      setExpandedReplies(prev => ({ ...prev, [commentId]: true }));
    } catch { showAlert('오류', '대댓글 작성에 실패했습니다.'); }
    finally { setReplyLoading(false); }
  };

  // ── 참가 신청 ──────────────────────────────────────────────
  const handleRequestJoin = async () => {
    if (!isLoggedIn) { showAlert('로그인 필요', '참가 신청은 로그인 후 이용할 수 있습니다.'); return; }
    try {
      setActionLoading(true);
      await requestJoinRecruit(recruitId, user.uid);
      await loadRecruit();
      showAlert('신청 완료 ✉️', '작성자가 수락하면 참가가 확정됩니다.');
    } catch (e) {
      const msg = e.message || '';
      if (msg.includes('permission') || msg.includes('PERMISSION_DENIED')) {
        showAlert('신청 불가', '권한이 없습니다. 잠시 후 다시 시도해주세요.');
      } else {
        showAlert('신청 실패', msg);
      }
    } finally { setActionLoading(false); }
  };

  // ── 신청 취소 ──────────────────────────────────────────────
  const handleCancelRequest = () => {
    showAlert('신청 취소', '참가 신청을 취소하시겠습니까?', [
      { text: '아니오', style: 'cancel' },
      { text: '취소하기', style: 'destructive', onPress: async () => {
        try {
          setActionLoading(true);
          await cancelJoinRequest(recruitId, user.uid);
          await loadRecruit();
        } catch (e) { showAlert('오류', e.message); }
        finally { setActionLoading(false); }
      }},
    ]);
  };

  // ── 참가 취소 (수락된 참가자) ──────────────────────────────
  // 80차 계속: bulkReserved(예약 확정) 이후엔 이 경로가 실제 예약 문서를 안 건드려서
  // 로스터-실제예약 불일치를 만드는 버그였음 — 이제 이 함수는 확정 전에만 쓰이고,
  // 확정 후엔 handleRequestSeatTransfer로 대체(footer 렌더링에서 분기).
  const handleLeave = () => {
    showAlert('참가 취소', '참가를 취소하시겠습니까?', [
      { text: '아니오', style: 'cancel' },
      { text: '취소하기', style: 'destructive', onPress: async () => {
        try {
          setActionLoading(true);
          await leaveRecruit(recruitId, user.uid);
          await loadRecruit();
        } catch (e) { showAlert('오류', e.message); }
        finally { setActionLoading(false); }
      }},
    ]);
  };

  // ── 자리 양도 요청/취소 (수락된 참가자, 예약 확정 후) ────────
  const handleRequestSeatTransfer = () => {
    showAlert('자리 양도', '자리를 양도하시겠습니까? 승인된 대체 인원이 정해지면 자리가 넘어가고 알림을 받아요.', [
      { text: '아니오', style: 'cancel' },
      { text: '양도 요청', onPress: async () => {
        try {
          setActionLoading(true);
          await requestSeatTransfer(recruitId, user.uid);
          await loadRecruit();
        } catch (e) { showAlert('오류', e.message); }
        finally { setActionLoading(false); }
      }},
    ]);
  };
  const handleCancelSeatTransfer = async () => {
    try {
      setActionLoading(true);
      await cancelSeatTransfer(recruitId);
      await loadRecruit();
    } catch (e) { showAlert('오류', e.message); }
    finally { setActionLoading(false); }
  };

  // ── 모임 후 매너 평가 ─────────────────────────────────────
  const handleRatePeer = async (rateeUid) => {
    if (!user?.uid || myPeerRatings.includes(rateeUid)) return;
    try {
      await submitPeerRating(recruitId, user.uid, rateeUid);
      setMyPeerRatings(prev => [...prev, rateeUid]);
      setMannerCounts(prev => ({ ...prev, [rateeUid]: (prev[rateeUid] || 0) + 1 }));
    } catch (e) { showAlert('오류', e.message); }
  };

  // ── 수락 ───────────────────────────────────────────────────
  // 80차 계속: recruit.openSeatUid가 켜져 있으면(자리 양도 진행 중) 정원이 이미 꽉 찬
  // 상태라 approveParticipant는 그 안의 "이미 정원이 가득 찼습니다" 체크에 매번 걸림 —
  // 이 경우는 신규 인원 추가가 아니라 기존 자리 재배정이므로 approveSeatTransfer로 분기.
  const handleApprove = async (uid) => {
    try {
      if (recruit?.openSeatUid) await approveSeatTransfer(recruitId, uid);
      else await approveParticipant(recruitId, uid);
      await loadRecruit();
    } catch (e) { showAlert('오류', e.message); }
  };

  // ── 거절 ───────────────────────────────────────────────────
  const handleReject = (uid, name) => {
    showAlert('신청 거절', `${name}님의 신청을 거절하시겠습니까?`, [
      { text: '취소', style: 'cancel' },
      { text: '거절', style: 'destructive', onPress: async () => {
        try {
          await rejectParticipant(recruitId, uid);
          await loadRecruit();
        } catch (e) { showAlert('오류', e.message); }
      }},
    ]);
  };

  // 79차: [버그 수정] 이미 승인된 참가자 목록의 "내보내기" 버튼이 handleReject(대기
  // 신청자 거절 전용, pendingParticipants→rejectedParticipants만 처리)를 그대로 쓰고
  // 있어서, 실제로는 participants 배열도 currentSlots도 전혀 안 바뀌는 완전히 무효한
  // 버튼이었음(전수 정독으로 발견) — 화면 새로고침 후에도 참가자가 그대로 남아있었음.
  // handleLeave(본인이 스스로 나가는 것)와 동일한 leaveRecruit()을 대상 uid로 호출하는
  // "강퇴" 전용 핸들러를 신규로 분리.
  const handleKick = (uid, name) => {
    showAlert('참가자 내보내기', `${name}님을 이 모집에서 내보내시겠습니까?`, [
      { text: '취소', style: 'cancel' },
      { text: '내보내기', style: 'destructive', onPress: async () => {
        try {
          await leaveRecruit(recruitId, uid);
          await loadRecruit();
        } catch (e) { showAlert('오류', e.message); }
      }},
    ]);
  };

  // ── 모집글 삭제 ────────────────────────────────────────────
  const handleDelete = () => {
    showAlert('삭제', '모집글을 삭제하시겠습니까?', [
      { text: '취소', style: 'cancel' },
      { text: '삭제', style: 'destructive', onPress: async () => {
        try {
          await deleteRecruit(recruitId);
          navigation.goBack();
        } catch {
          showAlert('오류', '모집글 삭제에 실패했어요. 다시 시도해주세요.');
        }
      }},
    ]);
  };

  // ── 신고 ───────────────────────────────────────────────────
  // 80차 계속: 모집글 공유 — recruitShareCF(웹 OG 미리보기 페이지)로 연결, 로그인
  // 여부와 무관하게 누구나 공유 가능(앱 밖 유저 유입이 목적이라 로그인 게이트를 걸
  // 이유가 없음). 네이티브 Share 시트(카카오톡 포함 OS 공유)를 그대로 사용.
  const handleShare = async () => {
    if (!recruit) return;
    try {
      await Share.share({
        message: `${recruit.title || recruit.productName} - UNLOCK에서 같이 갈 사람을 구해요!\nhttps://unlockapp.co.kr/r/${recruit.id}`,
      });
    } catch {}
  };

  const handleReport = () => {
    if (!isLoggedIn) { showAlert('로그인 필요', '신고는 로그인 후 이용할 수 있습니다.'); return; }
    if (reported) { showAlert('알림', '이미 신고한 모집글입니다.'); return; }
    showAlert(
      '신고 유형 선택',
      '신고 사유를 선택해주세요.',
      [
        { text: '취소', style: 'cancel' },
        { text: '허위 모집', onPress: () => submitReport('허위 모집') },
        { text: '욕설/비방', onPress: () => submitReport('욕설/비방') },
        { text: '노쇼/악성 사용자', onPress: () => submitReport('노쇼/악성 사용자') },
        { text: '기타', onPress: () => submitReport('기타') },
      ]
    );
  };

  const submitReport = async (reason) => {
    try {
      await submitReportSafe({
        recruitId,
        reporterUid:  user.uid,
        reporterName: profile?.nickname || '익명',
        targetUid:    recruit.uid,
        targetName:   recruit.authorName,
        reason,
        title:        recruit.title,
      });
      // 영구 중복 방지: users/{uid}/reportedRecruits 배열에 기록
      await addReportedRecruit(user.uid, recruitId).catch(() => {});
      setReported(true);
      showAlert('신고 완료', '신고가 접수되었습니다. 검토 후 조치하겠습니다.');
    } catch {
      showAlert('오류', '신고 처리 중 오류가 발생했습니다.');
    }
  };

  // ── 작성자 프로필 미리보기 ─────────────────────────────────
  // 78차 64차: getParticipantProfiles가 uid 배열 대신 recruitId를 받아 그 모집글의
  // 실제 참가자만 반환하도록 바뀜(보안 수정) — 작성자는 항상 participants에 포함돼
  // 있으므로 이미 로드해둔 participantProfiles에서 찾고, 아직 못 찾았을 때만 재조회.
  const handleAuthorPress = async () => {
    if (!recruit?.uid) return;
    try {
      const found = participantProfiles.find(p => p.uid === recruit.uid);
      const profiles = found ? [found] : await getParticipantProfiles(recruitId);
      setAuthorProfile(profiles.find(p => p.uid === recruit.uid) || { nickname: recruit.authorName });
      setAuthorModalVisible(true);
    } catch {
      setAuthorProfile({ nickname: recruit.authorName });
      setAuthorModalVisible(true);
    }
  };

  // ── 상단 노출 (포인트 차감) ────────────────────────────────
  const BOOST_COST  = 50;
  const BOOST_HOURS = 24;

  const isBoosted = (() => {
    if (!recruit?.boostedUntil) return false;
    const v  = recruit.boostedUntil;
    const ms = typeof v.toMillis === 'function' ? v.toMillis() : new Date(v).getTime();
    return ms > Date.now();
  })();

  const handleBoost = () => {
    if (!isLoggedIn) { showAlert('로그인 필요'); return; }
    if (isBoosted) {
      showAlert('상단 노출 중', '이미 상단 노출 중인 게시글입니다.');
      return;
    }
    const currentPoints = profile?.points ?? 0;
    if (currentPoints < BOOST_COST) {
      showAlert('포인트 부족', `상단 노출에는 ${BOOST_COST}P가 필요합니다.\n현재 보유: ${currentPoints}P`);
      return;
    }
    showAlert(
      '상단 노출',
      `${BOOST_COST}P를 사용해 ${BOOST_HOURS}시간 동안 모집 게시판 상단에 노출합니다.\n현재 보유: ${currentPoints}P`,
      [
        { text: '취소', style: 'cancel' },
        { text: `${BOOST_COST}P 사용`, onPress: async () => {
          setBoosting(true);
          try {
            // 75차: users.points 클라이언트 직접 차감 → permission-denied 원인이었음
            // (firestore.rules가 points 필드 클라 직접 수정을 차단, 53차 보안 조치).
            // 크루 생성/이름변경이 쓰는 것과 동일한 usePointsFIFO(CF 래퍼)로 교체.
            await usePointsFIFO(user.uid, BOOST_COST, `모집글 상단 노출 — ${recruit.title || ''}`);
            const boostedUntil = new Date(Date.now() + BOOST_HOURS * 60 * 60 * 1000).toISOString();
            await updateDoc(doc(db, 'recruits', recruitId), { boostedUntil });
            await refreshProfile();
            setRecruit(prev => ({ ...prev, boostedUntil }));
            showAlert('완료', `상단 노출이 ${BOOST_HOURS}시간 동안 적용됩니다!`);
          } catch {
            showAlert('오류', '상단 노출 처리 중 오류가 발생했습니다.');
          } finally { setBoosting(false); }
        }},
      ]
    );
  };

  // ── 재모집 ─────────────────────────────────────────────────
  const handleReRecruit = () => {
    showAlert(
      '재모집',
      '이 모집글과 동일한 내용으로 새 모집 글 작성 화면으로 이동합니다.\n날짜와 시간을 확인 후 등록해주세요.',
      [
        { text: '취소', style: 'cancel' },
        { text: '재모집 글 작성', onPress: () => {
          navigation.navigate('RecruitWrite', {
            prefill: {
              title:       recruit.title,
              productId:   recruit.productId || null,
              productName: recruit.productName || '',
              storeName:   recruit.storeName || '',
              imageUrl:    recruit.imageUrl || '',
              region:      recruit.region || '',
              scheduledTime: recruit.scheduledTime || '',
              totalSlots:  recruit.totalSlots,
              description: recruit.description || '',
              kakaoLink:   recruit.kakaoLink || null,
              difficulty:  recruit.difficulty || null,
              genres:      recruit.genres || [],
            },
          });
        }},
      ]
    );
  };

  // ── 일괄 예약 ──────────────────────────────────────────────
  // productId, scheduledDate, scheduledTime이 모두 있을 때만 활성화
  const canBulkReserve = !!(
    recruit?.productId &&
    recruit?.scheduledDate &&
    recruit?.scheduledTime
  );

  const handleBulkReserve = () => {
    if (!canBulkReserve) {
      showAlert(
        '예약 불가',
        '예약을 진행하려면 모집글에 테마, 날짜, 시간이 모두 등록되어 있어야 합니다.\n재모집 시 정보를 추가해주세요.',
      );
      return;
    }
    setReserveResults([]);
    setReserveModalVisible(true);
  };

  const executeBulkReserve = async () => {
    if (!recruit || !participantProfiles.length) return;

    // 이미 일괄 예약 완료된 경우 방어
    if (recruit.bulkReserved) {
      showAlert('알림', '이미 일괄 예약이 완료된 모집글입니다.');
      setReserveModalVisible(false);
      return;
    }

    setReserveLoading(true);

    // Batch Write로 원자적 일괄 저장
    try {
      // 80차 후속: 체험형(정원 공유) 테마는 서버 트랜잭션으로 정원을 원자적으로
      // 검증하는 별도 CF 경로를 탐(bulkReserveForRecruit은 방탈출 전용 정책 유지).
      // [버그 수정] product?.bookingFormat(비동기 조회 결과)로 분기하고 있어서, 그 조회가
      // 끝나기 전에 "일괄 예약"을 누르면 항상 room 경로로 잘못 빠질 수 있었음(레이스
      // 컨디션) — recruit 문서 자체에 이미 저장돼 있는 bookingFormat(동기, 항상 준비됨)으로 교체.
      if ((recruit?.bookingFormat || 'room') === 'show') {
        await bulkReserveShowForRecruit({
          recruit: { ...recruit, id: recruitId },
          productName: displayThemeName || recruit.productName,
          storeName:   displayStoreName  || recruit.storeName || '',
          participantUids: participantProfiles.map(p => p.uid),
          duration:    product?.duration ?? 60,
        });
      } else {
        await bulkReserveForRecruit({
          recruit: { ...recruit, id: recruitId },
          participants: participantProfiles,
          productName: displayThemeName || recruit.productName,
          storeName:   displayStoreName  || recruit.storeName || '',
          price:       product?.price ?? 0,
          duration:    product?.duration ?? 60,
        });
      }
      const results = participantProfiles.map(p => ({
        uid: p.uid,
        name: p.nickname || p.displayName || '익명',
        status: 'success',
      }));
      setReserveResults(results);
      await loadRecruit();
    } catch (e) {
      // Firestore 권한 오류 명시
      let msg = e.message || '알 수 없는 오류';
      if (e?.code === 'permission-denied' || e?.message?.includes('Missing or insufficient')) {
        msg = 'Firestore 권한이 없습니다. 관리자에게 보안 규칙 설정을 요청해주세요.';
      } else if (e?.message?.includes('SLOT_FULL')) {
        msg = '해당 회차 정원이 이미 가득 찼습니다.';
      } else if (e?.message?.includes('AGE_RESTRICTED')) {
        // 80차 후속: 19금 테마 — 참가자 중 미성년/생년월일 미등록자가 있어 그룹 전체가 거부됨
        msg = '이 테마는 만 19세 이상만 예약할 수 있어요. 참가자 전원이 생년월일을 등록해야 해요.';
      }
      setReserveResults([{
        uid: 'error',
        name: '전체',
        status: 'error',
        message: msg,
      }]);
    } finally {
      setReserveLoading(false);
    }
  };

  // 80차 후속: 그룹예약 취소 — 작성자 전용, 참가자 전원에게 알림이 감. room/show 둘 다
  // 기본 룰은 동일(사용자 요청) — 진입 CF만 형식별로 다름(room은 recruitId로 바로,
  // show는 정원 카운터가 개별 예약 문서 기준이라 본인 예약 id를 먼저 찾아서 진입).
  const handleCancelBulkReservation = () => {
    const isShow = (recruit.bookingFormat || 'room') === 'show';
    showAlert(
      '그룹 예약 취소',
      '일괄 예약한 그룹 전체가 취소돼요.\n참가자들에게 취소 알림이 발송됩니다.\n\n계속할까요?',
      [
        { text: '아니오', style: 'cancel' },
        { text: '취소하기', style: 'destructive', onPress: async () => {
          setBulkCancelLoading(true);
          try {
            if (isShow) {
              await cancelBulkShowReservation(recruit.id, user.uid);
            } else {
              await cancelBulkRoomReservation(recruit.id);
            }
            await loadRecruit();
            showAlert('완료', '그룹 예약이 취소됐어요.');
          } catch (e) {
            showAlert('오류', e?.message || '취소 처리 중 오류가 발생했어요.');
          } finally {
            setBulkCancelLoading(false);
          }
        }},
      ]
    );
  };

  const formatTime = (ts) => {
    if (!ts) return '';
    try {
      const d = ts.toDate ? ts.toDate() : new Date(ts);
      return `${d.getMonth()+1}/${d.getDate()} ${String(d.getHours()).padStart(2,'0')}:${String(d.getMinutes()).padStart(2,'0')}`;
    } catch { return ''; }
  };

  if (loading) return <LoadingOverlay />;
  if (!recruit) return (
    <View style={{ flex:1, backgroundColor:BG, justifyContent:'center', alignItems:'center' }}>
      <Text style={{ color:TEXT_MUTED, fontSize:15 }}>게시물을 찾을 수 없습니다.</Text>
      <TouchableOpacity onPress={() => navigation.goBack()} style={{ marginTop:16 }}>
        <Text style={{ color:GOLD, fontSize:14 }}>← 뒤로</Text>
      </TouchableOpacity>
    </View>
  );

  // 80차 후속: [기능 추가] 모집 목록에서는 확인된 미성년자에게 19금 모집글을 숨기고
  // 있는데, 알림·직접 링크 등으로 딥링크 진입하면 그 필터를 안 거쳐 그대로 노출되는
  // 사각지대가 있었음 — ThemeDetailScreen.js와 동일한 방식으로 상세 화면 렌더링
  // 단계에서만 차단.
  if (recruit.isAdultOnly && isConfirmedMinorBirth(profile?.birth)) return (
    <View style={{ flex:1, backgroundColor:BG }}>
      <AppHeader showBack centerElement={<Text style={{ color:COLORS.text, fontSize:15, fontWeight:'800' }}>모집글 상세</Text>} />
      <View style={{ flex:1, alignItems:'center', justifyContent:'center', padding:24, gap:12 }}>
        <Text style={{ color:COLORS.danger, fontSize:15, fontWeight:'700', textAlign:'center' }}>🔞 19세 이상만 볼 수 있는 모집글이에요</Text>
        <Text style={{ color:TEXT_MUTED, fontSize:13, textAlign:'center' }}>
          이 모집글은 만 19세 이상만 이용할 수 있는 테마예요.
        </Text>
      </View>
    </View>
  );

  const isAuthor      = user?.uid === recruit.uid;
  const isParticipant = recruit.participants?.includes(user?.uid);
  const isPending     = recruit.pendingParticipants?.includes(user?.uid);
  const isRejected    = recruit.rejectedParticipants?.includes(user?.uid);
  const isFull        = recruit.status === 'full';
  const isExpired     = (() => {
    if (!recruit.scheduledDate) return false;
    const base = new Date(recruit.scheduledDate);
    if (recruit.scheduledTime) {
      const [h, m] = recruit.scheduledTime.split(':').map(Number);
      base.setHours(h + 2, m, 0, 0);
    } else {
      base.setHours(23, 59, 59, 999);
    }
    return base < new Date();
  })();
  // 80차 계속: 모임 후 매너 평가를 열어도 되는 시점 — 실제로 예약이 확정된 모임이
  // 예정 시각을 지났을 때만(단순히 모집 마감기한이 지난 것과는 다름).
  const meetupOver = isExpired && recruit.bulkReserved === true;
  const ratio = (recruit.currentSlots || 1) / recruit.totalSlots;

  const dDay = (() => {
    if (!recruit.scheduledDate || isExpired) return null;
    const today = new Date(); today.setHours(0,0,0,0);
    const target = new Date(recruit.scheduledDate); target.setHours(0,0,0,0);
    const diff = Math.round((target - today) / (1000 * 60 * 60 * 24));
    if (diff === 0) return { label: 'D-Day', color: RED };
    if (diff <= 3)  return { label: `D-${diff}`, color: ORANGE };
    return { label: `D-${diff}`, color: GOLD };
  })();

  const isMatchComplete = isFull && !isExpired && (recruit.participants?.length ?? 0) >= recruit.totalSlots;

  const getLevel = (total = 0) =>
    total >= 50 ? { label: '전문가', color: PURPLE }
  : total >= 20 ? { label: '고수',   color: GOLD }
  : total >= 5  ? { label: '중급',   color: GREEN }
  :               { label: '입문',   color: TEXT_MUTED };

  // ── 작성자 프로필 모달 ─────────────────────────────────────


  // ── 참가자 카드 렌더 ───────────────────────────────────────
  const renderParticipantCard = (p, showActions = false) => {
    const isMe      = p.uid === user?.uid;
    const isAuthorP = p.uid === recruit?.uid;
    const isPrivate = p.statsPrivate === true;
    const level     = getLevel(p.escapeStats?.total);
    const avatarLetter = (p.nickname || p.displayName || '?')[0].toUpperCase();

    return (
      <View key={p.uid} style={[s.pCard, isMe && s.pCardMe]}>
        <View style={s.pTop}>
          {p.photoURL ? (
            <Image
              source={{ uri: p.photoURL }}
              style={[s.pAvatarImg, isAuthorP && { borderColor: GOLD, borderWidth: 2 }]}
            />
          ) : (
            <View style={[s.pAvatar, {
              backgroundColor: isAuthorP ? GOLD+'30' : isMe ? GOLD+'15' : 'rgba(255,255,255,0.08)',
            }]}>
              {isAuthorP
                ? <CrownIcon size={16} color={GOLD} />
                : <Text style={{ fontSize: 18 }}>{isMe ? '🙋' : avatarLetter}</Text>}
            </View>
          )}
          <View style={{ flex:1 }}>
            <View style={{ flexDirection:'row', alignItems:'center', gap:6, flexWrap:'wrap' }}>
              <Text style={[s.pName, isMe && { color:GOLD }]}>
                {p.nickname || p.displayName || '익명'}
                {isMe ? ' (나)' : ''}{isAuthorP ? ' · 작성자' : ''}
              </Text>
              <View style={[s.levelBadge, { borderColor:level.color+'60', backgroundColor:level.color+'15' }]}>
                <Text style={[s.levelTxt, { color:level.color }]}>{level.label}</Text>
              </View>
            </View>
            {p.bio ? <Text style={s.pBio} numberOfLines={1}>{p.bio}</Text> : null}
          </View>
          {showActions && isAuthor && !isAuthorP && (
            <TouchableOpacity
              style={s.rejectBtn}
              onPress={() => handleKick(p.uid, p.nickname || '이 참가자')}>
              <Text style={{ color:RED, fontSize:11 }}>내보내기</Text>
            </TouchableOpacity>
          )}
        </View>
        {/* 80차 계속: AuthorProfileModal과 동일한 신뢰 신호 블록 — 노쇼 이력은 항상,
            선호 장르는 statsPrivate(본인 것 제외)일 때만 가림, 성공률은 제거. */}
        <View style={s.statsRow}>
          <View style={s.statItem}>
            <Text style={[s.statVal, { color: (p.recentNoShowCount || 0) > 0 ? ORANGE : GREEN }]}>
              {(p.recentNoShowCount || 0) > 0 ? `${p.recentNoShowCount}회` : '없음'}
            </Text>
            <Text style={s.statLbl}>최근 노쇼</Text>
          </View>
          <View style={s.statItem}>
            <Text style={[s.statVal, { color: GOLD }]} numberOfLines={1}>
              {isPrivate && !isMe ? '비공개' : (p.favoriteGenre || '-')}
            </Text>
            <Text style={s.statLbl}>선호 장르</Text>
          </View>
          {/* 80차 계속: 모임 후 매너 평가 집계 — 확정 참가자 목록(showActions)에서만
              조회해두므로 그 컨텍스트에서만 표시(신청 대기자 카드엔 아직 없음). */}
          {showActions && (
            <View style={s.statItem}>
              <Text style={[s.statVal, { color: GOLD }]}>
                {mannerCounts[p.uid] || 0}
              </Text>
              <Text style={s.statLbl}>매너 좋아요</Text>
            </View>
          )}
        </View>
        {/* 80차 계속: 모임이 실제로 끝난 뒤에만, 나 아닌 다른 참가자에게 매너 평가 가능 —
            이모지(👍) 대신 claude.ai/design "UNLOCK 에셋" 이식 아이콘(MannerLikeIcon) 사용 */}
        {showActions && meetupOver && !isMe && (
          <TouchableOpacity
            style={[s.rateBtn, myPeerRatings.includes(p.uid) && s.rateBtnDone]}
            disabled={myPeerRatings.includes(p.uid)}
            onPress={() => handleRatePeer(p.uid)}>
            <IconLabel
              Icon={MannerLikeIcon}
              size={13}
              color={myPeerRatings.includes(p.uid) ? s.rateBtnDoneTxt.color : GOLD}
              textStyle={[s.rateBtnTxt, myPeerRatings.includes(p.uid) && s.rateBtnDoneTxt]}>
              {myPeerRatings.includes(p.uid) ? '또 하고 싶어요 (완료)' : '또 하고 싶어요'}
            </IconLabel>
          </TouchableOpacity>
        )}
      </View>
    );
  };

  return (
    <View style={s.container}>
      <AuthorProfileModal
        visible={authorModalVisible}
        profile={authorProfile}
        onClose={() => setAuthorModalVisible(false)}
        getLevel={getLevel}
      />
      <BulkReserveModal
        visible={reserveModalVisible}
        onClose={() => { setReserveModalVisible(false); setReserveResults([]); }}
        recruit={recruit}
        participantProfiles={participantProfiles}
        displayThemeName={displayThemeName}
        displayStoreName={displayStoreName}
        reserveLoading={reserveLoading}
        reserveResults={reserveResults}
        onExecute={executeBulkReserve}
      />

      {/* 75차: 자체 커스텀 헤더(뒤로가기만) → 공통 AppHeader로 교체(다른 화면과 동일
          패턴 누락분). 신고/수정/삭제 등 우측 액션은 rightElement로 이동 */}
      <AppHeader showBack
        centerElement={<Text style={{ color: TEXT, fontSize: 15, fontWeight: '800' }} numberOfLines={1}>모집글 상세</Text>}
        rightElement={
        <View style={{ flexDirection:'row', alignItems:'center', gap:4 }}>
          <TouchableOpacity onPress={handleShare}>
            <IconLabel Icon={ShareIcon} size={s.reportBtn.fontSize || 12} color={s.reportBtn.color} textStyle={s.reportBtn}>공유</IconLabel>
          </TouchableOpacity>
          {isLoggedIn && !isAuthor && (
            <TouchableOpacity onPress={handleReport}>
              <IconLabel Icon={ReportFlagIcon} size={s.reportBtn.fontSize || 12} color={s.reportBtn.color} textStyle={s.reportBtn}>신고</IconLabel>
            </TouchableOpacity>
          )}
          {isAuthor && pendingProfiles.length > 0 && (
            <View style={s.pendingAlertBadge}>
              <IconLabel Icon={RecruitAppliedIcon} size={12} color={ORANGE} textStyle={s.pendingAlertTxt}>
                {pendingProfiles.length}명 신청
              </IconLabel>
            </View>
          )}
          {/* 78차: 상단 노출 버튼 — 기존엔 본문 중간에 큰 골드 배너로 있어 "너무 크고
              한가운데" 신고됨. 옆의 수정/삭제와 같은 헤더 소형 버튼 톤으로 이동/축소.
              비용·시간 안내는 handleBoost의 확인 Alert에 이미 있어 여기선 라벨만 표시. */}
          {isAuthor && !isExpired && !isFull && (
            <SecondaryButton
              label={boosting ? '···' : isBoosted ? '노출중' : '노출'}
              onPress={handleBoost}
              disabled={boosting || isBoosted}
              style={s.headerBtnCompact}
              textStyle={s.headerBtnCompactTxt}
            />
          )}
          {isAuthor && !isExpired && !isFull && (
            <SecondaryButton
              label="수정"
              onPress={() => navigation.navigate('RecruitWrite', { recruit })}
              style={s.headerBtnCompact}
              textStyle={s.headerBtnCompactTxt}
            />
          )}
          {isAuthor && (
            <DangerButton
              label="삭제"
              onPress={handleDelete}
              style={s.headerBtnCompact}
              textStyle={s.headerBtnCompactTxt}
            />
          )}
        </View>
      } />

      <KeyboardAvoidingView style={{ flex:1 }} behavior={Platform.OS === 'ios' ? 'padding' : undefined}>
        <ScrollView ref={scrollRef} contentContainerStyle={s.body}
          showsVerticalScrollIndicator={false} keyboardShouldPersistTaps="handled">

          {/* ── 테마 히어로 이미지 ────────────────────────── */}
          {recruit.imageUrl ? (
            <Image source={{ uri: recruit.imageUrl }} style={s.themeHeroImage} contentFit="cover" />
          ) : (
            // 이미지 없을 때: 자물쇠 제거, 테마 이름 첫 글자 or 빈 배경
            <View style={s.themeHeroPlaceholder}>
              <Text style={s.themeHeroPlaceholderText}>
                {displayThemeName ? displayThemeName[0] : '?'}
              </Text>
            </View>
          )}

          {/* ── 상태 + D-Day + 조회수 ─────────────────────── */}
          <View style={s.statusRow}>
            <View style={{ flexDirection:'row', gap:6, alignItems:'center' }}>
              <View style={[s.statusBadge, (isFull || isExpired) && s.statusBadgeFull]}>
                <IconLabel
                  Icon={isExpired ? ClockIcon : isFull ? CheckmarkIcon : PeopleIcon}
                  size={12} color={(isFull || isExpired) ? RED : COLORS.gold}
                  textStyle={[s.statusTxt, (isFull || isExpired) && { color:RED }]}>
                  {isExpired ? '기간만료' : isFull ? '모집완료' : '모집중'}
                </IconLabel>
              </View>
              {dDay && (
                <View style={[s.dDayBadge, { borderColor: dDay.color+'50', backgroundColor: dDay.color+'15' }]}>
                  <Text style={[s.dDayTxt, { color: dDay.color }]}>{dDay.label}</Text>
                </View>
              )}
            </View>
            <IconLabel Icon={ViewsIcon} size={12} color={TEXT_SEC} textStyle={s.viewCount}>{recruit.viewCount||0}</IconLabel>
          </View>

          {/* ── 제목 ──────────────────────────────────────── */}
          <Text style={s.title}>{recruit.title}</Text>

          {/* ── 작성자 + 지역 ─────────────────────────────── */}
          <View style={s.metaInfoRow}>
            {recruit.region && (
              <View style={s.metaInfoItem}>
                <LocationIcon size={12} color={TEXT_SEC} />
                <Text style={s.metaInfoTxt}>{recruit.region}</Text>
              </View>
            )}
            {recruit.authorName && (
              <TouchableOpacity style={s.metaInfoItem} onPress={handleAuthorPress} activeOpacity={0.7}>
                <PersonIcon size={s.metaInfoIcon.fontSize || 13} color={GOLD} />
                <Text style={[s.metaInfoTxt, { color: GOLD }]}>{recruit.authorCrewName ? `[${recruit.authorCrewName}] ` : ''}{recruit.authorName}</Text>
                <Text style={{ color: GOLD, fontSize: 11 }}> 프로필 보기→</Text>
              </TouchableOpacity>
            )}
          </View>

          {/* ── 테마 정보 카드 (자물쇠 아이콘 제거) ──────── */}
          <View style={s.themeCard}>
            <View style={{ flex:1 }}>
              {/* 80차 후속: 모집글 목록 카드와 동일하게 방탈출/체험형 뱃지 — 형식에 따라
                  일괄예약 흐름·인원 개념이 달라 미리 알 수 있게 항상 노출 */}
              <View style={{ flexDirection:'row', gap:6, marginBottom:4 }}>
                <View style={[s.formatBadge, (recruit.bookingFormat||'room')==='show'
                  ? { backgroundColor: COLORS.blue+'22', borderColor: COLORS.blue+'50' }
                  : { backgroundColor: COLORS.green+'22', borderColor: COLORS.green+'50' }]}>
                  <Text style={[s.formatBadgeTxt, { color: (recruit.bookingFormat||'room')==='show' ? COLORS.blue : COLORS.green }]}>
                    {(recruit.bookingFormat||'room')==='show' ? '체험형' : '방탈출'}
                  </Text>
                </View>
                {/* 80차 후속: [정책 확정] 배지 순서 — ①형식(위) → ②19금 */}
                {recruit.isAdultOnly && (
                  <View style={[s.formatBadge, { backgroundColor: COLORS.dangerBg, borderColor: COLORS.danger+'50' }]}>
                    <Text style={[s.formatBadgeTxt, { color: COLORS.danger }]}>19금</Text>
                  </View>
                )}
              </View>
              {/* 테마명 */}
              <Text style={s.themeCardName} numberOfLines={1}>
                {displayThemeName || '테마 미정'}
              </Text>

              {/* 매장명: recruit.storeName 우선, 없으면 product에서 조합 */}
              <Text style={s.themeCardStore} numberOfLines={1}>
                {displayStoreName || '매장 정보 없음'}
              </Text>

              {/* 지점명 별도 표기 (product로 조회 시 branchName 있는 경우) */}
              {!recruit.storeName && product?.branchName ? (
                <Text style={[s.themeCardStore, { fontSize:11, marginTop:1 }]} numberOfLines={1}>
                  지점: {product.branchName}
                </Text>
              ) : null}

              {/* 날짜·시간 */}
              {recruit.scheduledDate && (
                <View style={{ flexDirection:'row', alignItems:'center', gap:8 }}>
                  <IconLabel Icon={MenuReservationIcon} size={11} color="rgba(212,168,67,0.8)" textStyle={s.themeCardDate}>{recruit.scheduledDate}</IconLabel>
                  {recruit.scheduledTime ? <IconLabel Icon={MenuPointsIcon} size={11} color="rgba(212,168,67,0.8)" textStyle={s.themeCardDate}>{recruit.scheduledTime}</IconLabel> : null}
                </View>
              )}

              {/* 지역 태그 (product에 city/district 있는 경우 보완) */}
              {!recruit.region && product?.city ? (
                <IconLabel Icon={LocationIcon} size={11} color={TEXT_MUTED} textStyle={[s.themeCardDate, { color:TEXT_MUTED }]}>{product.city}{product.district ? ` · ${product.district}` : ''}</IconLabel>
              ) : null}
            </View>

            {/* 인원 배지 */}
            <View style={[s.slotBadge, (isFull || isExpired) && s.slotBadgeFull]}>
              <Text style={[s.slotBadgeTxt, (isFull || isExpired) && { color:RED }]}>
                {recruit.currentSlots||1}/{recruit.totalSlots}
              </Text>
              <Text style={[s.slotBadgeLbl, (isFull || isExpired) && { color:RED+'AA' }]}>명</Text>
            </View>
          </View>

          {/* ── 인원 진행바 ───────────────────────────────── */}
          <View style={s.slotSection}>
            <View style={s.slotBar}>
              <View style={[s.slotFill, { width:`${ratio*100}%`, backgroundColor: (isFull||isExpired)?RED:GOLD }]} />
            </View>
            <Text style={s.slotTxt}>{recruit.currentSlots||1}/{recruit.totalSlots}명 참가중</Text>
          </View>

          {/* ── 신청자 관리 (작성자 전용) ─────────────────── */}
          {/* 80차 계속: openSeatUid가 켜져 있으면 이 목록은 신규 인원 추가가 아니라
              양도된 자리를 채울 대체 인원 지원자 목록 — 라벨/안내문만 구분(수락 로직
              자체는 handleApprove에서 이미 분기됨). */}
          {isAuthor && pendingProfiles.length > 0 && (
            <View style={s.pendingSection}>
              <View style={s.pendingHeader}>
                <IconLabel Icon={RecruitAppliedIcon} size={14} color={COLORS.gold} textStyle={s.sectionTitle}>
                  {recruit.openSeatUid ? '대체 인원 신청 대기' : '참가 신청 대기'}
                </IconLabel>
                <View style={s.pendingBadge}>
                  <Text style={s.pendingBadgeTxt}>{pendingProfiles.length}</Text>
                </View>
              </View>
              <Text style={{ color:TEXT_MUTED, fontSize:12, marginBottom:10 }}>
                {recruit.openSeatUid
                  ? '참가자 한 명이 자리 양도를 요청했어요. 프로필을 확인하고 대체 인원을 승인해주세요.'
                  : '프로필을 확인하고 수락 또는 거절해주세요.'}
              </Text>
              {pendingProfiles.map(p => (
                <View key={p.uid} style={s.pendingCard}>
                  {renderParticipantCard(p, false)}
                  <View style={s.pendingActions}>
                    <TouchableOpacity
                      style={s.approveBtn}
                      onPress={() => handleApprove(p.uid)}>
                      <IconLabel Icon={ParticipantAcceptIcon} size={13} color={s.approveTxt.color || GREEN} textStyle={s.approveTxt}>수락</IconLabel>
                    </TouchableOpacity>
                    <TouchableOpacity
                      style={s.rejectBtnLarge}
                      onPress={() => handleReject(p.uid, p.nickname || '이 분')}>
                      <IconLabel Icon={RecruitRejectedIcon} size={13} color={s.rejectTxt.color || RED} textStyle={s.rejectTxt}>거절</IconLabel>
                    </TouchableOpacity>
                  </View>
                </View>
              ))}
            </View>
          )}

          {/* ── 참가자 명단 (접기/펼치기) ────────────────── */}
          {(participantProfiles.length > 0 || (recruit.currentSlots || 1) >= 1) && (
            <View style={s.pSection}>
              <TouchableOpacity
                style={s.pSectionHeader}
                onPress={() => setParticipantsExpanded(v => !v)}
                activeOpacity={0.7}>
                <IconLabel Icon={PeopleIcon} size={14} color={GOLD} textStyle={s.sectionTitle}>참가자 ({recruit.currentSlots || 1}명)</IconLabel>
                <Text style={{ color: GOLD, fontSize: 13, fontWeight: '700' }}>
                  {participantsExpanded ? '접기 ▲' : '펼치기 ▼'}
                </Text>
              </TouchableOpacity>

              {!participantsExpanded && (
                <View style={s.pCollapsedRow}>
                  {/* 작성자 항상 표시 */}
                  {recruit.uid && (() => {
                    const isInList = participantProfiles.some(p => p.uid === recruit.uid);
                    if (isInList) return null;
                    const authorName = recruit.authorName || recruit.nickname || '작성자';
                    return (
                      <View key="author" style={s.pCollapsedItem}>
                        <View style={[s.pCollapsedAvatarFallback, { backgroundColor: GOLD + '30' }]}>
                          <CrownIcon size={13} color={GOLD} />
                        </View>
                        <Text style={s.pCollapsedName} numberOfLines={1}>{authorName}</Text>
                        <View style={[s.levelBadge, { borderColor: GOLD + '50', backgroundColor: GOLD + '12' }]}>
                          <Text style={[s.levelTxt, { color: GOLD }]}>작성자</Text>
                        </View>
                      </View>
                    );
                  })()}
                  {participantProfiles.map(p => {
                    const isAuthorP = p.uid === recruit?.uid;
                    const level = getLevel(p.escapeStats?.total);
                    const avatarLetter = (p.nickname || p.displayName || '?')[0].toUpperCase();
                    return (
                      <View key={p.uid} style={s.pCollapsedItem}>
                        {p.photoURL ? (
                          <Image source={{ uri: p.photoURL }} style={[s.pCollapsedAvatar, isAuthorP && { borderColor: GOLD }]} />
                        ) : (
                          <View style={[s.pCollapsedAvatarFallback, isAuthorP && { backgroundColor: GOLD+'30' }]}>
                            {isAuthorP ? <CrownIcon size={13} color={GOLD} /> : <Text style={{ fontSize: 13 }}>{avatarLetter}</Text>}
                          </View>
                        )}
                        <Text style={s.pCollapsedName} numberOfLines={1}>
                          {p.nickname || p.displayName || '익명'}
                        </Text>
                        <View style={[s.levelBadge, { borderColor: level.color+'50', backgroundColor: level.color+'12' }]}>
                          <Text style={[s.levelTxt, { color: level.color }]}>{level.label}</Text>
                        </View>
                      </View>
                    );
                  })}
                </View>
              )}

              {participantsExpanded && participantProfiles.map(p => renderParticipantCard(p, true))}
            </View>
          )}

          {/* ── 모집 완료 카드 + 일괄 예약 버튼 ─────────── */}
          {isMatchComplete && (
            <View style={s.matchCompleteCard}>
              <IconLabel Icon={MatchCompleteIcon} size={16} color={GREEN} textStyle={s.matchCompleteTitle}>파티 매칭 완료!</IconLabel>
              <Text style={s.matchCompleteSub}>
                총 {recruit.totalSlots}명이 모였어요. 오픈채팅으로 일정을 조율하거나{'\n'}
                아래 버튼으로 예약을 바로 진행해보세요.
              </Text>
              {recruit.kakaoLink && (
                <TouchableOpacity
                  style={s.matchKakaoBtn}
                  onPress={() => Linking.openURL(recruit.kakaoLink)}>
                  <IconLabel Icon={CrewMessageIcon} size={13} color="#3C1E1E" textStyle={s.matchKakaoBtnTxt}>오픈채팅 바로가기</IconLabel>
                </TouchableOpacity>
              )}

              {/* 일괄 예약 버튼 — 작성자 전용 */}
              {isAuthor && (
                recruit.bulkReserved ? (
                  <View style={s.bulkReserveDoneBox}>
                    <IconLabel Icon={CheckmarkIcon} size={13} color={s.bulkReserveDoneTxt.color || GREEN} textStyle={s.bulkReserveDoneTxt}>일괄 예약 완료</IconLabel>
                    <Text style={s.bulkReserveDoneSub}>예약 내역에서 확인하세요</Text>
                    {/* 80차 후속: 사용자 요청 — 체험형(show)도 방탈출(room)과 동일하게
                        작성자 직접 취소 허용(형식 무관하게 항상 노출) */}
                    <TouchableOpacity
                      onPress={handleCancelBulkReservation}
                      disabled={bulkCancelLoading}
                      style={{ marginTop: 10 }}>
                      <Text style={{ color: COLORS.danger, fontSize: 12, fontWeight: '700', textAlign: 'center' }}>
                        {bulkCancelLoading ? '취소 처리 중...' : '그룹 예약 취소'}
                      </Text>
                      </TouchableOpacity>
                  </View>
                ) : (
                  <TouchableOpacity
                    style={[s.bulkReserveBtn, !canBulkReserve && s.bulkReserveBtnDisabled]}
                    onPress={handleBulkReserve}>
                    <MenuReservationIcon size={20} color={canBulkReserve ? COLORS.gold : TEXT_MUTED} />
                    <View>
                      <Text style={[s.bulkReserveBtnTxt, !canBulkReserve && { color:TEXT_MUTED }]}>
                        멤버 일괄 예약하기
                      </Text>
                      <Text style={s.bulkReserveBtnSub}>
                        {canBulkReserve
                          ? `${participantProfiles.length}명 · ${recruit.scheduledDate} ${recruit.scheduledTime}`
                          : '테마·날짜·시간 등록 후 이용 가능'}
                      </Text>
                    </View>
                  </TouchableOpacity>
                )
              )}

              {!recruit.kakaoLink && isAuthor && (
                <Text style={{ color: TEXT_MUTED, fontSize: 12, marginTop: 10, textAlign: 'center' }}>
                  오픈채팅 링크를 추가하면 참가자들이 쉽게 입장할 수 있어요.
                </Text>
              )}
            </View>
          )}

          {/* 상세 설명 */}
          {recruit.description ? (
            <View style={s.descSection}>
              <IconLabel Icon={EditIcon} size={14} color={GOLD} textStyle={s.sectionTitle}>상세 설명</IconLabel>
              <Text style={s.descTxt}>{recruit.description}</Text>
            </View>
          ) : null}

          {/* 오픈채팅: 매칭 완료 카드 내부 버튼만 표시, 단독 노출 제거 */}
          {/* 78차: 상단 노출 버튼은 헤더 소형 버튼으로 이동(위 AppHeader rightElement 참고) */}

          {/* ── 작성자 전용 하단 액션 — 재모집만 (수정은 헤더 버튼으로 이동) ─── */}
          {isAuthor && (isExpired || isFull) && (
            <TouchableOpacity
              style={s.reRecruitBtn}
              onPress={handleReRecruit}
              disabled={actionLoading}>
              {actionLoading
                ? <ActivityIndicator color={BG} />
                : (
                  <View style={{ flexDirection:'row', alignItems:'center', gap:8 }}>
                    <RefreshIcon size={18} color={GOLD} />
                    <View>
                      <Text style={s.reRecruitTxt}>재모집 하기</Text>
                      <Text style={s.reRecruitSub}>같은 내용으로 작성 화면 이동</Text>
                    </View>
                  </View>
                )}
            </TouchableOpacity>
          )}

          {/* ── 댓글 섹션 ─────────────────────────────────── */}
          <View style={s.commentSection}>
            <IconLabel Icon={MenuInquiryIcon} size={14} color={COLORS.gold} textStyle={s.sectionTitle}>댓글 {visibleComments.length > 0 ? `(${visibleComments.length})` : ''}</IconLabel>
            {!commentsLoaded ? (
              <ActivityIndicator color={GOLD} style={{ marginVertical:16 }} />
            ) : visibleComments.length === 0 ? (
              <View style={s.commentEmpty}>
                <Text style={{ color:TEXT_MUTED, fontSize:13 }}>첫 댓글을 남겨보세요!</Text>
              </View>
            ) : (
              visibleComments.map(c => {
                const isMine = c.uid === user?.uid;
                const avatarLetter = (c.authorName || '?')[0].toUpperCase();
                const commentLevel = (() => {
                  if (c.statsPrivate && !isMine) return null;
                  const total = c.escapeStats?.total ?? null;
                  if (total === null) return null;
                  if (total >= 50) return { label: '초고수', color: PURPLE };
                  if (total >= 20) return { label: '고수',   color: GOLD };
                  if (total >= 5)  return { label: '중급',   color: GREEN };
                  return                { label: '입문',   color: TEXT_MUTED };
                })();
                return (
                  <View key={c.id} style={[s.commentItem, isMine && s.commentItemMine]}>
                    <View style={s.commentMeta}>
                      {c.photoURL ? (
                        <Image
                          source={{ uri: c.photoURL }}
                          style={[s.commentAvatar, isMine && { borderColor:GOLD+'60' }]}
                        />
                      ) : (
                        <View style={[s.commentAvatarFallback, isMine && { backgroundColor:GOLD+'20', borderColor:GOLD+'60' }]}>
                          <Text style={[s.commentAvatarTxt, isMine && { color:GOLD }]}>{avatarLetter}</Text>
                        </View>
                      )}
                      <Text style={[s.commentAuthor, isMine && { color:GOLD }]}>
                        {isMine ? '나' : c.authorName || '익명'}
                      </Text>
                      {commentLevel && (
                        <View style={[s.commentLevelBadge, {
                          borderColor: commentLevel.color + '60',
                          backgroundColor: commentLevel.color + '18',
                        }]}>
                          <Text style={[s.commentLevelTxt, { color: commentLevel.color }]}>
                            {commentLevel.label}
                          </Text>
                        </View>
                      )}
                      <View style={{ flex: 1 }} />
                      {isMine && (
                        <TouchableOpacity onPress={() => handleDeleteComment(c.id)}
                          hitSlop={{ top:8, bottom:8, left:8, right:8 }}>
                          <Text style={{ color:RED, fontSize:11 }}>삭제</Text>
                        </TouchableOpacity>
                      )}
                    </View>
                    <Text style={s.commentTxt}>{c.text}</Text>
                    <View style={{ flexDirection:'row', justifyContent:'space-between', alignItems:'center', marginTop:4 }}>
                      {c.createdAt ? (
                        <Text style={s.commentTime}>{formatTime(c.createdAt)}</Text>
                      ) : <View />}
                      <View style={{ flexDirection:'row', alignItems:'center', gap:12 }}>
                        <LikeButton liked={!!user?.uid && c.likedBy?.includes(user.uid)} count={c.likedBy?.length || 0}
                          onToggle={() => handleToggleCommentLike(c)} disabled={!user?.uid} />
                        {isLoggedIn && (
                          <TouchableOpacity
                            onPress={() => {
                              setReplyTo(replyTo?.id === c.id ? null : { id: c.id, authorName: c.authorName });
                              setReplyText('');
                            }}
                            hitSlop={{ top:6, bottom:6, left:6, right:6 }}>
                            <Text style={{ color:GOLD, fontSize:10, fontWeight:'700' }}>
                              {replyTo?.id === c.id ? '취소' : '↩ 답글'}
                            </Text>
                          </TouchableOpacity>
                        )}
                      </View>
                    </View>
                    {/* 대댓글 입력창 */}
                    {replyTo?.id === c.id && (
                      <View style={s.replyInputRow}>
                        <TextInput
                          ref={replyInputRef}
                          style={s.replyInput}
                          value={replyText}
                          onChangeText={setReplyText}
                          onFocus={() => scrollInputIntoView(replyInputRef)}
                          placeholder={`@${c.authorName || '익명'} 에게 답글...`}
                          placeholderTextColor={TEXT_MUTED}
                          maxLength={200}
                          autoFocus
                        />
                        <GradientButton
                          label={replyLoading ? '전송 중...' : '전송'}
                          onPress={() => handleAddReply(c.id)}
                          disabled={!replyText.trim()||replyLoading}
                          style={s.replySendBtn}
                          textStyle={s.replySendTxt}
                        />
                      </View>
                    )}
                    {/* 대댓글 목록 */}
                    <ReplyList
                      recruitId={recruitId}
                      commentId={c.id}
                      myUid={user?.uid}
                      expanded={expandedReplies[c.id] || false}
                      onToggle={() => setExpandedReplies(prev => ({ ...prev, [c.id]: !prev[c.id] }))}
                      formatTime={formatTime}
                      blockedUsers={blockedUsers}
                    />
                  </View>
                );
              })
            )}
            {isLoggedIn ? (
              <View style={s.commentInputRow}>
                <TextInput
                  ref={commentInputRef}
                  style={s.commentInput}
                  value={commentText}
                  onChangeText={setCommentText}
                  onFocus={() => scrollInputIntoView(commentInputRef)}
                  placeholder="댓글을 입력하세요..."
                  placeholderTextColor={TEXT_MUTED}
                  multiline maxLength={300}
                />
                <GradientButton
                  label={commentLoading ? '전송 중...' : '전송'}
                  onPress={handleAddComment}
                  disabled={!commentText.trim()||commentLoading}
                  style={s.commentSendBtn}
                  textStyle={s.commentSendTxt}
                />
              </View>
            ) : (
              <SecondaryButton
                label="로그인하고 댓글을 남겨보세요 →"
                onPress={() => navigation.navigate('Login')}
                style={s.loginPrompt}
                textStyle={{ fontSize:13 }}
              />
            )}
          </View>

          {/* 80차 계속: 참가자 전용 비공개 채팅 — 댓글(공개)과 완전히 분리된 섹션.
              작성자가 켰고(recruit.privateChatEnabled) 내가 승인된 참가자일 때만 노출 —
              firestore.rules가 실제 접근권한을 다시 강제하므로 이 조건은 UI 노출용. */}
          {canSeeChat && (
            <View style={s.commentSection}>
              <IconLabel Icon={PrivacyLockIcon} size={14} color={COLORS.gold} textStyle={s.sectionTitle}>
                참가자 전용 채팅 {chatMessages.length > 0 ? `(${chatMessages.length})` : ''}
              </IconLabel>
              <Text style={{ color:TEXT_MUTED, fontSize:11, marginTop:-6, marginBottom:12 }}>
                이 모집에 참가 확정된 사람만 볼 수 있어요. 전화번호·상세 집합 장소 등을 편하게 나눠보세요.
              </Text>
              {visibleChatMessages.length === 0 ? (
                <View style={s.commentEmpty}>
                  <Text style={{ color:TEXT_MUTED, fontSize:13 }}>아직 메시지가 없어요. 먼저 인사해보세요!</Text>
                </View>
              ) : visibleChatMessages.map(m => {
                const isMine = m.uid === user?.uid;
                return (
                  <View key={m.id} style={{ marginBottom:10 }}>
                    <View style={{ flexDirection:'row', alignItems:'center', gap:6 }}>
                      <Text style={{ color:isMine ? GOLD : TEXT, fontSize:12, fontWeight:'700' }}>{m.nickname}</Text>
                      {m.createdAt && <Text style={s.commentTime}>{formatTime(m.createdAt)}</Text>}
                    </View>
                    <Text style={s.commentTxt}>{m.text}</Text>
                  </View>
                );
              })}
              <View style={s.commentInputRow}>
                <TextInput
                  ref={chatInputRef}
                  style={s.commentInput}
                  value={chatText}
                  onChangeText={setChatText}
                  onFocus={() => scrollInputIntoView(chatInputRef)}
                  placeholder="메시지를 입력하세요..."
                  placeholderTextColor={TEXT_MUTED}
                  multiline maxLength={300}
                />
                <GradientButton
                  label={chatSending ? '전송 중...' : '전송'}
                  onPress={handleSendChat}
                  disabled={!chatText.trim()||chatSending}
                  style={s.commentSendBtn}
                  textStyle={s.commentSendTxt}
                />
              </View>
            </View>
          )}

          <View style={{ height:100 }} />
        </ScrollView>
      </KeyboardAvoidingView>

      {/* ── 하단 액션 버튼 ────────────────────────────────── */}
      {!isAuthor && !isExpired && (
        <View style={[s.footer, { paddingBottom: footerPadBottom }]}>
          {isParticipant ? (
            // 80차 계속: bulkReserved(예약 확정) 이후엔 참가 취소 대신 자리 양도로 —
            // handleLeave는 이제 확정 전 로스터에서만 쓰임(leaveRecruit 자체도 서버에서
            // bulkReserved면 거부).
            recruit.bulkReserved ? (
              recruit.openSeatUid === user?.uid ? (
                <DangerButton
                  label={actionLoading ? '처리 중...' : '양도 요청 취소'}
                  onPress={handleCancelSeatTransfer}
                  disabled={actionLoading}
                  style={s.footerDangerBtn}
                />
              ) : recruit.openSeatUid ? (
                <View style={s.pendingFooter}>
                  <IconLabel Icon={HourglassIcon} size={13} color={s.pendingFooterTxt?.color} textStyle={s.pendingFooterTxt}>
                    다른 참가자의 자리 양도가 진행 중이에요.
                  </IconLabel>
                </View>
              ) : (
                <SecondaryButton
                  label={actionLoading ? '처리 중...' : '이 자리 양도 요청'}
                  onPress={handleRequestSeatTransfer}
                  disabled={actionLoading}
                  style={s.footerDangerBtn}
                />
              )
            ) : (
              <DangerButton
                label={actionLoading ? '처리 중...' : '참가 취소'}
                onPress={handleLeave}
                disabled={actionLoading}
                style={s.footerDangerBtn}
              />
            )
          ) : isPending ? (
            <View style={{ gap:8 }}>
              <View style={s.pendingFooter}>
                <IconLabel Icon={HourglassIcon} size={13} color={s.pendingFooterTxt?.color} textStyle={s.pendingFooterTxt}>
                  작성자의 수락을 기다리는 중...
                </IconLabel>
              </View>
              <DangerButton
                label={actionLoading ? '처리 중...' : '신청 취소'}
                onPress={handleCancelRequest}
                disabled={actionLoading}
                style={s.footerDangerBtn}
              />
            </View>
          ) : isRejected ? (
            <View style={s.rejectedFooter}>
              <IconLabel Icon={RecruitRejectedIcon} size={13} color={s.rejectedTxt.color || RED} textStyle={s.rejectedTxt}>이 모집에서 거절되었습니다.</IconLabel>
              <SecondaryButton
                label="다른 모집글 둘러보기 →"
                // 79차: [버그 수정] 'Recruit'는 GeneralTabNavigator 안에 nested된 탭 이름이라
                // top-level AppStack 화면인 이 화면(RecruitDetail)에서 bare navigate로는
                // 못 찾음(FavoritesScreen.js 등이 겪었던 것과 동일한 버그 유형 — navigation/
                // index.js 전체를 top-level vs nested 탭 이름으로 교차검증해 발견) — 거절된
                // 모집글에서 이 버튼을 누르면 아무 반응도 없었을 것.
                onPress={() => navigation.navigate('Main', { screen: 'Recruit' })}
                style={s.rejectedSubBtn}
                textStyle={s.rejectedSubTxt}
              />
            </View>
          ) : (
            // 80차 계속: openSeatUid(자리 양도 요청 중)가 켜져 있으면 isFull이어도
            // 그 한 자리에 지원 가능 — requestJoinRecruit도 동일 기준으로 이미 풀어둠.
            <GradientButton
              label={actionLoading ? '처리 중...' : (isFull && !recruit.openSeatUid ? '모집이 마감되었습니다' : recruit.openSeatUid ? '대체 인원 신청하기' : '참가 신청하기')}
              onPress={handleRequestJoin}
              disabled={(isFull && !recruit.openSeatUid) || actionLoading}
            />
          )}
        </View>
      )}
    </View>
  );
}

const s = StyleSheet.create({
  container: { flex:1, backgroundColor:BG },
  reportBtn: { color:ORANGE, fontSize:13, fontWeight:'600' },
  body:      { paddingBottom:40 },

  // 헤더 신청 대기 뱃지
  pendingAlertBadge: { backgroundColor:ORANGE+'22', borderRadius:8, borderWidth:1,
                       borderColor:ORANGE+'60', paddingHorizontal:9, paddingVertical:4 },
  pendingAlertTxt:   { color:ORANGE, fontSize:11, fontWeight:'800' },

  // 일괄 예약 완료 박스
  bulkReserveDoneBox: { backgroundColor:COLORS.greenBg, borderRadius:12, borderWidth:1,
                        borderColor:COLORS.greenBorder, paddingVertical:10, paddingHorizontal:16,
                        marginTop:12, width:'100%', alignItems:'center', gap:3 },
  bulkReserveDoneTxt: { color:GREEN, fontSize:14, fontWeight:'800' },
  bulkReserveDoneSub: { color:TEXT_MUTED, fontSize:11 },

  // 테마 히어로 이미지
  themeHeroImage:            { width:'100%', height:200 },
  themeHeroPlaceholder:      { width:'100%', height:140,
                               backgroundColor:'rgba(212,168,67,0.04)',
                               alignItems:'center', justifyContent:'center',
                               borderBottomWidth:1, borderBottomColor:BORDER },
  themeHeroPlaceholderText:  { fontSize:52, color:GOLD, fontWeight:'900', opacity:0.25 },

  statusRow:      { flexDirection:'row', alignItems:'center', justifyContent:'space-between',
                    marginBottom:12, paddingHorizontal:20, paddingTop:16 },
  statusBadge:    { backgroundColor:GOLD+'22', borderRadius:6, paddingHorizontal:10, paddingVertical:4,
                    borderWidth:1, borderColor:GOLD+'44' },
  statusBadgeFull:{ backgroundColor:COLORS.redBg, borderColor:COLORS.redBorder },
  statusTxt:      { color:GOLD, fontSize:12, fontWeight:'700' },
  // 77차: design 폴더 Badge/Chip 스펙(pill, radius 999)에 맞춰 모양만 조정 —
  // 색 로직(오늘=red/3일이내=orange/그 외=gold 3단계)은 DDayBadge(2단계: urgent/chill)보다
  // 정보량이 많아 그대로 유지, 셸(shape)만 스펙 정합.
  dDayBadge:      { borderRadius:999, paddingHorizontal:11, paddingVertical:5, borderWidth:1 },
  dDayTxt:        { fontSize:11, fontWeight:'700' },
  // 80차 후속: 방탈출/체험형 뱃지 — 다른 뱃지들과 같은 pill 셸에 맞춤
  formatBadge:    { borderRadius:999, paddingHorizontal:10, paddingVertical:4, borderWidth:1 },
  formatBadgeTxt: { fontSize:11, fontWeight:'700' },
  // 78차 38차: 작성자 + 신청 대기 + 노출/수정/삭제 3버튼이 한꺼번에 뜨면 AppHeader의
  // right 컬럼(flex:1, 화면폭의 1/3)보다 실제 버튼 폭 합이 넓어져 왼쪽 center 제목("모집글
  // 상세")을 가리던 버그 — 패딩/간격을 줄여 실제 폭을 축소.
  headerBtnCompact:    { paddingVertical:4, paddingHorizontal:8, borderRadius:8 },
  headerBtnCompactTxt: { fontSize:11 },
  viewCount:      { color:TEXT_MUTED, fontSize:12 },
  title:          { color:TEXT, fontSize:20, fontWeight:'900', lineHeight:28,
                    marginBottom:8, paddingHorizontal:20 },

  metaInfoRow:    { flexDirection:'row', flexWrap:'wrap', gap:12, paddingHorizontal:20, marginBottom:16 },
  metaInfoItem:   { flexDirection:'row', alignItems:'center', gap:4 },
  metaInfoIcon:   { fontSize:13 },
  metaInfoTxt:    { color:TEXT_SEC, fontSize:13 },

  // 테마 카드 (자물쇠 아이콘 컬럼 제거)
  themeCard:      { flexDirection:'row', alignItems:'center', gap:12,
                    backgroundColor:'rgba(212,168,67,0.06)', borderRadius:14,
                    borderWidth:1, borderColor:'rgba(212,168,67,0.30)',
                    padding:14, marginBottom:16, marginHorizontal:20 },
  themeCardName:  { color:TEXT, fontSize:15, fontWeight:'800', marginBottom:2 },
  themeCardStore: { color:TEXT_SEC, fontSize:12, marginBottom:3 },
  themeCardDate:  { color:'rgba(212,168,67,0.8)', fontSize:12, fontWeight:'600' },

  slotBadge:      { alignItems:'center', justifyContent:'center',
                    backgroundColor:'rgba(212,168,67,0.12)', borderRadius:10,
                    borderWidth:1, borderColor:'rgba(212,168,67,0.3)',
                    paddingHorizontal:10, paddingVertical:6, minWidth:44 },
  slotBadgeFull:  { backgroundColor:COLORS.redBg, borderColor:COLORS.redBorder },
  slotBadgeTxt:   { color:GOLD, fontSize:16, fontWeight:'900' },
  slotBadgeLbl:   { color:'rgba(212,168,67,0.6)', fontSize:10 },

  slotSection: { marginBottom:20, paddingHorizontal:20 },
  slotBar:     { height:8, backgroundColor:'rgba(255,255,255,0.1)', borderRadius:4, overflow:'hidden', marginBottom:6 },
  slotFill:    { height:'100%', borderRadius:4 },
  slotTxt:     { color:TEXT_SEC, fontSize:13, textAlign:'right' },

  sectionTitle: { color:GOLD, fontSize:15, fontWeight:'800', marginBottom:10 },

  pendingSection: { backgroundColor:ORANGE+'10', borderRadius:14, borderWidth:1,
                    borderColor:ORANGE+'40', padding:14, marginBottom:20, marginHorizontal:20 },
  pendingHeader:  { flexDirection:'row', alignItems:'center', gap:8, marginBottom:6 },
  pendingBadge:   { backgroundColor:ORANGE, borderRadius:10, paddingHorizontal:8,
                    paddingVertical:2, minWidth:22, alignItems:'center' },
  pendingBadgeTxt:{ color:'#fff', fontSize:11, fontWeight:'800' },
  pendingCard:    { backgroundColor:SURFACE, borderRadius:12, borderWidth:1,
                    borderColor:BORDER, marginBottom:10, overflow:'hidden' },
  pendingActions: { flexDirection:'row', gap:8, padding:12,
                    borderTopWidth:1, borderTopColor:BORDER },
  approveBtn:     { flex:1, backgroundColor:GREEN+'20', borderRadius:10, borderWidth:1,
                    borderColor:GREEN+'60', paddingVertical:10, alignItems:'center' },
  approveTxt:     { color:GREEN, fontWeight:'800', fontSize:13 },
  rejectBtnLarge: { flex:1, backgroundColor:RED+'15', borderRadius:10, borderWidth:1,
                    borderColor:RED+'50', paddingVertical:10, alignItems:'center' },
  rejectTxt:      { color:RED, fontWeight:'800', fontSize:13 },

  pSection:    { marginBottom:16, paddingHorizontal:20 },
  pSectionHeader: { flexDirection:'row', justifyContent:'space-between', alignItems:'center', marginBottom:10 },

  pCollapsedRow:  { flexDirection:'row', flexWrap:'wrap', gap:8 },
  pCollapsedItem: { alignItems:'center', gap:3, minWidth:64, maxWidth:80 },
  pCollapsedAvatar: { width:36, height:36, borderRadius:18, borderWidth:2, borderColor:'rgba(255,255,255,0.15)' },
  pCollapsedAvatarFallback: { width:36, height:36, borderRadius:18, backgroundColor:'rgba(255,255,255,0.08)',
                              borderWidth:1.5, borderColor:'rgba(255,255,255,0.15)',
                              alignItems:'center', justifyContent:'center' },
  pCollapsedName: { color:TEXT_SEC, fontSize:11, fontWeight:'600', textAlign:'center' },

  pCard:       { backgroundColor:SURFACE, borderRadius:12, borderWidth:1,
                 borderColor:BORDER, padding:12, marginBottom:8 },
  pCardMe:     { borderColor:GOLD+'50', backgroundColor:GOLD+'06' },
  pTop:        { flexDirection:'row', alignItems:'center', gap:10, marginBottom:8 },
  pAvatar:     { width:38, height:38, borderRadius:19, alignItems:'center', justifyContent:'center' },
  pAvatarImg:  { width:38, height:38, borderRadius:19, borderWidth:1, borderColor:'rgba(255,255,255,0.15)' },
  pName:       { color:TEXT, fontSize:13, fontWeight:'700' },
  pBio:        { color:TEXT_MUTED, fontSize:11, marginTop:2 },
  levelBadge:  { borderRadius:6, borderWidth:1, paddingHorizontal:7, paddingVertical:2 },
  levelTxt:    { fontSize:10, fontWeight:'800' },
  statsRow:    { flexDirection:'row', gap:8 },
  statItem:    { flex:1, backgroundColor:SURFACE2, borderRadius:8, padding:8,
                 alignItems:'center', borderWidth:1, borderColor:BORDER },
  statVal:     { fontSize:14, fontWeight:'900', marginBottom:2 },
  statLbl:     { color:TEXT_MUTED, fontSize:10 },
  privateRow:  { backgroundColor:SURFACE2, borderRadius:8, padding:8,
                 alignItems:'center', borderWidth:1, borderColor:BORDER },
  rejectBtn:   { paddingHorizontal:10, paddingVertical:6, borderRadius:8,
                 borderWidth:1, borderColor:RED+'50', backgroundColor:RED+'10' },
  // 80차 계속: 모임 후 매너 평가 버튼
  rateBtn:       { marginTop:8, paddingVertical:8, borderRadius:8, alignItems:'center',
                   borderWidth:1, borderColor:GOLD+'50', backgroundColor:GOLD+'10' },
  rateBtnDone:   { borderColor:BORDER, backgroundColor:SURFACE2 },
  rateBtnTxt:    { color:GOLD, fontSize:12, fontWeight:'700' },
  rateBtnDoneTxt:{ color:TEXT_MUTED },

  descSection: { marginBottom:20, paddingHorizontal:20 },
  descTxt:     { color:TEXT_SEC, fontSize:14, lineHeight:22 },

  kakaoBtn:    { backgroundColor:'#FEE500', borderRadius:12, height:50,
                 justifyContent:'center', alignItems:'center', marginBottom:20, marginHorizontal:20 },
  kakaoBtnTxt: { color:'#3C1E1E', fontSize:15, fontWeight:'800' },

  reRecruitBtn: { backgroundColor:'rgba(212,168,67,0.12)', borderRadius:14, padding:16,
                  borderWidth:1, borderColor:'rgba(212,168,67,0.35)', marginBottom:0,
                  marginHorizontal:20 },
  reRecruitTxt: { color:GOLD, fontSize:15, fontWeight:'800' },
  reRecruitSub: { color:TEXT_MUTED, fontSize:11, marginTop:2 },

  editBtn: { backgroundColor:COLORS.greenBg, borderRadius:14, padding:16,
             borderWidth:1, borderColor:COLORS.greenBorder,
             marginHorizontal:20, marginBottom:0 },
  editBtnTxt: { color:GREEN, fontSize:15, fontWeight:'800' },
  editBtnSub: { color:TEXT_MUTED, fontSize:11, marginTop:2 },

  commentSection:  { borderTopWidth:1, borderTopColor:BORDER, paddingTop:20, paddingHorizontal:20 },
  commentEmpty:    { backgroundColor:SURFACE, borderRadius:10, padding:20,
                     alignItems:'center', marginBottom:16, borderWidth:1, borderColor:BORDER },
  commentItem:     { backgroundColor:SURFACE, borderRadius:8, padding:8, marginBottom:6,
                     borderWidth:1, borderColor:BORDER },
  commentItemMine: { borderColor:GOLD+'40', backgroundColor:GOLD+'08' },
  commentMeta:     { flexDirection:'row', alignItems:'center', gap:6, marginBottom:4 },
  commentAvatar:        { width:26, height:26, borderRadius:13, borderWidth:1.5, borderColor:'rgba(255,255,255,0.2)' },
  commentAvatarFallback:{ width:26, height:26, borderRadius:13, borderWidth:1.5,
                          borderColor:'rgba(255,255,255,0.2)', backgroundColor:'rgba(255,255,255,0.08)',
                          alignItems:'center', justifyContent:'center' },
  commentAvatarTxt:     { fontSize:11, fontWeight:'800', color:'rgba(255,255,255,0.6)' },
  commentAuthor:   { color:TEXT_SEC, fontSize:12, fontWeight:'700' },
  commentLevelBadge: { borderRadius:5, borderWidth:1, paddingHorizontal:5, paddingVertical:1 },
  commentLevelTxt:   { fontSize:10, fontWeight:'800' },
  commentTime:     { color:TEXT_MUTED, fontSize:10, textAlign:'right', marginTop:4 },
  commentTxt:      { color:TEXT, fontSize:13, lineHeight:18, marginTop:2 },

  // 매칭 완료 카드
  matchCompleteCard: { backgroundColor:COLORS.greenBg, borderRadius:14, borderWidth:1,
                       borderColor:COLORS.greenBorder, padding:16, marginBottom:20, marginHorizontal:20,
                       alignItems:'center' },
  matchCompleteTitle:{ color:GREEN, fontSize:16, fontWeight:'900', marginBottom:6 },
  matchCompleteSub:  { color:TEXT_SEC, fontSize:13, textAlign:'center', lineHeight:20, marginBottom:10 },
  matchKakaoBtn:     { backgroundColor:'#FEE500', borderRadius:10, paddingVertical:12, paddingHorizontal:28,
                       marginTop:4 },
  matchKakaoBtnTxt:  { color:'#3C1E1E', fontSize:14, fontWeight:'800' },

  // 일괄 예약 버튼 (매칭 완료 카드 내부)
  bulkReserveBtn:         { flexDirection:'row', alignItems:'center', gap:10,
                            backgroundColor:'rgba(212,168,67,0.12)', borderRadius:12,
                            borderWidth:1, borderColor:GOLD+'40',
                            paddingVertical:12, paddingHorizontal:16, marginTop:12, width:'100%' },
  bulkReserveBtnDisabled: { backgroundColor:'rgba(255,255,255,0.04)', borderColor:BORDER },
  bulkReserveBtnIcon:     { fontSize:20 },
  bulkReserveBtnTxt:      { color:GOLD, fontSize:14, fontWeight:'800' },
  bulkReserveBtnSub:      { color:TEXT_MUTED, fontSize:11, marginTop:2 },

  // 일괄 예약 모달 내부
  bulkInfoBox:       { backgroundColor:SURFACE2, borderRadius:10, borderWidth:1,
                       borderColor:BORDER, padding:12, marginBottom:14, gap:4 },
  bulkInfoRow:       { color:TEXT_SEC, fontSize:13, lineHeight:20 },
  bulkParticipantRow:{ flexDirection:'row', alignItems:'center', gap:10,
                       paddingVertical:8, borderBottomWidth:1, borderBottomColor:BORDER },
  bulkAvatar:        { width:32, height:32, borderRadius:16, borderWidth:1.5,
                       borderColor:BORDER },
  bulkReserveExecuteBtn: { backgroundColor:GOLD, borderRadius:12, height:50,
                           justifyContent:'center', alignItems:'center', marginTop:6 },
  bulkReserveExecuteTxt: { color:BG, fontSize:15, fontWeight:'800' },
  bulkResultSummary:     { backgroundColor:GREEN+'15', borderRadius:10, borderWidth:1,
                           borderColor:GREEN+'40', padding:12, marginBottom:12, alignItems:'center' },
  bulkResultSummaryTxt:  { color:GREEN, fontSize:14, fontWeight:'800' },
  bulkResultRow:         { flexDirection:'row', alignItems:'center', gap:10,
                           paddingVertical:8, borderBottomWidth:1, borderBottomColor:BORDER },
  bulkResultIcon:        { fontSize:16, width:20 },
  bulkResultError:       { backgroundColor:RED+'12', borderRadius:10, borderWidth:1,
                           borderColor:RED+'40', padding:14, marginBottom:12 },

  // 작성자 프로필 모달
  modalOverlay:    { flex:1, backgroundColor:'rgba(0,0,0,0.6)', justifyContent:'center',
                     alignItems:'center', padding:32 },
  authorModal:     { backgroundColor:SURFACE, borderRadius:20, padding:20, width:'100%',
                     borderWidth:1, borderColor:BORDER },
  authorModalTop:  { flexDirection:'row', alignItems:'center', gap:12, marginBottom:12 },
  authorModalAvatar: { width:52, height:52, borderRadius:26, borderWidth:2, borderColor:GOLD+'40' },
  authorModalAvatarFallback: { width:52, height:52, borderRadius:26, backgroundColor:GOLD+'15',
                               borderWidth:2, borderColor:GOLD+'40', alignItems:'center', justifyContent:'center' },
  authorModalName:  { color:TEXT, fontSize:16, fontWeight:'800', marginBottom:4 },
  authorModalBio:   { color:TEXT_MUTED, fontSize:13, fontStyle:'italic', textAlign:'center',
                      marginBottom:12, lineHeight:18 },
  authorModalClose: { marginTop:14, paddingVertical:8,
                      borderTopWidth:1, borderTopColor:BORDER },

  commentInputRow: { flexDirection:'row', gap:8, marginTop:12, alignItems:'flex-end' },
  commentInput:    { flex:1, backgroundColor:SURFACE2, borderWidth:1, borderColor:BORDER,
                     borderRadius:10, paddingHorizontal:14, paddingVertical:10,
                     color:TEXT, fontSize:14, maxHeight:100 },
  commentSendBtn:  { paddingHorizontal:16, paddingVertical:12 },
  commentSendTxt:  { fontSize:13 },
  loginPrompt:     { marginTop:12 },
  // 대댓글
  replyInputRow:   { flexDirection:'row', gap:6, marginTop:8, alignItems:'flex-end' },
  replyInput:      { flex:1, backgroundColor:'#0f0f1a', borderWidth:1, borderColor:BORDER,
                     borderRadius:8, paddingHorizontal:10, paddingVertical:7,
                     color:TEXT, fontSize:12, maxHeight:80 },
  replySendBtn:    { paddingHorizontal:12, paddingVertical:8 },
  replySendTxt:    { fontSize:11 },

  footer:          { padding:16, paddingBottom:32, backgroundColor:BG,
                     borderTopWidth:1, borderTopColor:BORDER },
  // 77차: joinBtn/leaveBtn(자체 구현) → 공용 GradientButton/DangerButton으로 교체,
  // 풀폭 유지용 셸 스타일만 남김
  footerDangerBtn: { width:'100%' },
  pendingFooter:   { backgroundColor:ORANGE+'15', borderRadius:10, height:44,
                     justifyContent:'center', alignItems:'center', borderWidth:1, borderColor:ORANGE+'40' },
  pendingFooterTxt:{ color:ORANGE, fontSize:13, fontWeight:'700' },
  rejectedFooter:  { backgroundColor:RED+'15', borderRadius:12, borderWidth:1,
                     borderColor:RED+'40', paddingVertical:12, paddingHorizontal:16,
                     alignItems:'center', gap:8 },
  rejectedTxt:     { color:RED, fontSize:14, fontWeight:'700' },
  rejectedSubBtn:  { paddingHorizontal:14, paddingVertical:6 },
  rejectedSubTxt:  { fontSize:12 },
});